[
  [
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 2462,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 1729,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 1413,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 1081,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 931,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 418,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 344,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 177,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 154,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 136,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 85,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 58,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 21,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 3,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 2853,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 2250,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 1570,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 1427,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 957,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 419,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 345,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 211,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 160,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 136
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 115,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 21
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 18,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 4,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 3260,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 2261,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 1796,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 1678,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 985,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 419
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 348,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 211
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 160
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 138,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 116,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 21
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 8,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 3303,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 2403,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 2140,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 1985,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 1034,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 544,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 419
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 237,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 164,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 160
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 139,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 68
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 26,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 20
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 9,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 2
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 3549,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 2658,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 2356,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 2334,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 1079,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 546,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 421,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 253,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 241,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 162,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 139
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 81,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 29,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 20
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 11,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 3582,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 2985,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 2708,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 2659,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 1177,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 549,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 422,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 278,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 250,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 162
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 139
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 30,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 20
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 11
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Saint Augustine's University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 1
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 4558,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 4156,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 3318,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 2735,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 1247,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 625,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 426,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 415,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 261,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 168,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 139
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 100,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 35,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 24,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 11
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 5,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 3
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 1,
      "timestamp": "2023-02-27T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 5953,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 4770,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 3718,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 3553,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 1351,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 631,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 605,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 439,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 299,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 182,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 149,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 113,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 70,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 62,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 39,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 25,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 6,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T08:00:00-05:00",
      "votes": 1
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 6629,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 5756,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 3929,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 3652,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 1440,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 754,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 634,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 449,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 356,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 240,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 198,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 128,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 76,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 75,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 74,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 28,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 10,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 3,
      "timestamp": "2023-02-27T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 7509,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 6805,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 4906,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 4341,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 1500,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 1066,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 792,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 457,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 376,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 348,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 309,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 260,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 148,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 106,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 87,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 27,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T10:00:00-05:00",
      "votes": 10
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T10:00:00-05:00",
      "votes": 3
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 8709,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 7445,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 5599,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 4999,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 1939,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 1436,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 1317,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 1269,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 559,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 533,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 532,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 379,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 373,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 125,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 120,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 49,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 43,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 16,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 4,
      "timestamp": "2023-02-27T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 9425,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 7972,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 6102,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 5375,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 2522,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 2239,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 2027,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 1896,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 1501,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 685,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 632,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 397,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 383,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 184,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 128,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 69,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 43,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 21,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T12:00:00-05:00",
      "votes": 4
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 10613,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 8712,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 6560,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 5714,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 2822,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 2460,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 2262,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 1935,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 1852,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 866,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 688,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 433,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 387,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 246,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 211,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 107,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 85,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 80,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 5,
      "timestamp": "2023-02-27T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 11524,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 9755,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 7622,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 6232,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 2891,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 2785,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 2491,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 2412,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 2107,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 954,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 943,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 469,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 408,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 332,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 255,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 244,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 141,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 120,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 72,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 12,
      "timestamp": "2023-02-27T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 12438,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 11047,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 8464,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 6396,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 3692,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 3330,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 2812,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 2600,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 2535,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 1163,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 1114,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 818,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 510,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 452,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 450,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 272,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 233,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 162,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 103,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 18,
      "timestamp": "2023-02-27T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 13597,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 11736,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 8851,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 6572,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 4271,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 3680,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 3304,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 2909,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 2844,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 1377,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 1272,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 1192,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 557,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 519,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 491,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 280,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 260,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 240,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 182,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 33,
      "timestamp": "2023-02-27T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 14975,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 12955,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 9533,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 7203,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 4598,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 3931,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 3674,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 3232,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 2961,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 1572,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 1491,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 1232,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 585,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 541,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 497,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 349,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 284,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 243,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 216,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 39,
      "timestamp": "2023-02-27T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 15683,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 13829,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 9621,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 7912,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 4904,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 4501,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 3870,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 3617,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 3561,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 1843,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 1693,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 1283,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 628,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 579,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 525,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 422,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 317,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 292,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 237,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T18:00:00-05:00",
      "votes": 39
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 16577,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 14567,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 10215,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 8386,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 5290,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 4919,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 4163,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 4029,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 3800,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 2114,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 1910,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 1525,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 725,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 685,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 558,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 525,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 412,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 349,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 291,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 42,
      "timestamp": "2023-02-27T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 18886,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 16107,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 12029,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 9142,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 5719,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 4935,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 4718,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 4642,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 4428,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 2394,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 2278,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 1886,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 762,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 721,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 713,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 604,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 455,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 446,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 361,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 46,
      "timestamp": "2023-02-27T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 19612,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 16890,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 12696,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 9984,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 7096,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 5681,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 5652,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 5306,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 4983,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 2808,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 2449,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 1938,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 934,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 790,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 768,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 651,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 534,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 514,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 370,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 55,
      "timestamp": "2023-02-27T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 20376,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 18066,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 13872,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 11053,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 7702,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 6313,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 5978,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 5643,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5021,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 3341,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 3274,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2060,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1145,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 864,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 809,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 758,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 583,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 522,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 374,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 57,
      "timestamp": "2023-02-27T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 21399,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 18436,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 14835,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 12060,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 8257,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 6391,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 6117,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 5784,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5100,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 3686,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 3319,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2081,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1244,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 881,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 851,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 827,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 630,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 553,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 380,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 60,
      "timestamp": "2023-02-27T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 23755,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 18719,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 15677,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 12558,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 8665,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 6958,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 6423,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 6153,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5161,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 3756,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 3729,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2191,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1301,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 935,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 887,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 873,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 663,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 556,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 401,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 61,
      "timestamp": "2023-02-28T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 25069,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 19056,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 16418,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 12804,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 8693,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 7075,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 7041,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 6176,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5233,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 3923,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 3808,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2226,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1310,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1013,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 899,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 879,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 697,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 558,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 404,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 62,
      "timestamp": "2023-02-28T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 25399,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 19414,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 16465,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 13140,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 8906,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 7201,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 7053,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 6215,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5239,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4107,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 3852,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2249,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1312,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1091,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 900,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 897,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 706,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T02:00:00-05:00",
      "votes": 558
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 405,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T02:00:00-05:00",
      "votes": 62
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 25837,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 19837,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 16781,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 13662,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 9178,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 7277,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 7119,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 6256,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5241,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4109,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 3884,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2253,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1313,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1100,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 910,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 909,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 768,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 558
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 405
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 62
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 26413,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 20088,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 17210,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 13748,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 9257,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 7664,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 7528,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 6333,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5243,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4110,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 3918,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 2253
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1319,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1105,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 910,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 910
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 815,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 561,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 405
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 62
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 27381,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 20148,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 17509,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 13956,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 9367,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 7732,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 7687,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 6485,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5247,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4112,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 3945,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2255,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1375,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1109,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 919,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 919,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 911,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 563,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 406,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T05:00:00-05:00",
      "votes": 62
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 28009,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 20573,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 18299,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 14620,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 9673,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 7819,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 7804,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 6674,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5255,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4163,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 3987,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2257,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1383,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1118,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1077,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 974,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-02-28T06:00:00-05:00",
      "votes": 911
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 593,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 416,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T06:00:00-05:00",
      "votes": 62
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 28936,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 20892,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 18739,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 14837,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 9809,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 8373,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 8298,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 6775,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5256,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4396,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 4181,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2265,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1388,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1186,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1135,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 992,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 917,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 645,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 426,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 64,
      "timestamp": "2023-02-28T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 29926,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 21144,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 19701,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 15391,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 10080,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 8759,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 8465,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 6929,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5267,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4650,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 4362,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2275,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1408,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1272,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1150,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 1014,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 994,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 655,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 430,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T08:00:00-05:00",
      "votes": 64
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 31841,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 22053,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 20356,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 15735,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 10614,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 9101,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 8706,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 7074,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5316,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4691,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 4532,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2287,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1427,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1303,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1180,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 1065,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1052,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 663,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 439,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 65,
      "timestamp": "2023-02-28T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 32952,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 22626,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 21485,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 15895,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 11266,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 9489,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 9102,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 7245,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 5900,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 5074,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4762,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2318,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1437,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1327,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1323,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 1129,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1073,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 676,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 449,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 67,
      "timestamp": "2023-02-28T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 33840,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 23600,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 21946,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 16045,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 11749,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 9901,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 9334,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 7449,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 6621,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 5352,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 4918,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2330,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1591,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1511,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1350,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 1252,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1136,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 713,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 488,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 80,
      "timestamp": "2023-02-28T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 34632,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 24300,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 22987,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 16639,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 12490,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 10744,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 9581,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 7945,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 7340,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 5558,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 5152,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2343,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 1778,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1520,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1445,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 1441,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1162,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 718,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 509,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 82,
      "timestamp": "2023-02-28T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 35356,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 25576,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 23854,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 17214,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 13340,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 11533,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 10016,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 8388,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 8384,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 5758,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 5248,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2410,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 2097,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 1579,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1544,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1497,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1186,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 723,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 521,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 84,
      "timestamp": "2023-02-28T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 36351,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 26350,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 24288,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 17466,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 14293,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 12340,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 10660,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 9000,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 8832,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 6013,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 5675,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2427,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 2292,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 1685,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1556,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1519,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1192,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 728,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 537,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 85,
      "timestamp": "2023-02-28T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 36869,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 27290,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 25726,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 17698,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 14742,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 13017,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 10998,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 9305,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 9227,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 6394,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 5940,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 2581,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2429,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 1848,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1572,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1569,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1249,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 729,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 542,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T15:00:00-05:00",
      "votes": 85
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 37362,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 28253,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 26485,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 18274,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 15391,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 13070,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 11264,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 10292,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 9633,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 6727,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 6047,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 2942,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2434,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 1909,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1592,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1580,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1339,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 736,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 547,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 86,
      "timestamp": "2023-02-28T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 39675,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 29179,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 26948,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 18779,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 15756,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 13472,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 11594,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 10580,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 9946,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 7056,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 6353,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 3198,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2445,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 2063,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1718,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1587,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1381,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 742,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 550,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 87,
      "timestamp": "2023-02-28T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 40463,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 30273,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 28020,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 19282,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 16595,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 13684,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 12032,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 10634,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 10157,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 7308,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 6528,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 3434,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2506,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 2211,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1807,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1590,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1478,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 767,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 554,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T18:00:00-05:00",
      "votes": 87
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 41029,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 30937,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 29574,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 19748,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 17705,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 14258,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 12863,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 10657,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 10347,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 7698,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 6657,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 3691,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2534,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 2332,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 1925,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1634,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1600,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 869,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 565,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T19:00:00-05:00",
      "votes": 87
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 42270,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 32013,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 30774,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 20467,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 18321,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 14986,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 13486,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11083,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 10523,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 7931,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 6871,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 3840,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2538,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 2476,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2059,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1789,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1701,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 875,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 586,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 89,
      "timestamp": "2023-02-28T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 43562,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 33074,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 31872,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 21252,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 18776,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 15325,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 13805,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11245,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 11114,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 8196,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 7312,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 3977,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 2819,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2542,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2133,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1886,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1745,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 916,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 592,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 90,
      "timestamp": "2023-02-28T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 45384,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 34579,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 33406,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 22217,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 19521,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 16282,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 14779,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 11764,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11360,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 8452,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 7652,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4141,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3082,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2547,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2274,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 1995,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1809,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 918,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 596,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 91,
      "timestamp": "2023-02-28T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 47077,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 36473,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 34927,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 22964,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 20086,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 16761,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 15165,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12158,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11372,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 8629,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 7779,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4248,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3301,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2550,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2425,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2008,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1831,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 979,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 606,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 95,
      "timestamp": "2023-02-28T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 47987,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 37029,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 35150,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 23729,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 20279,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 17646,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 15457,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12274,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11600,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 8727,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 8198,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4329,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3365,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2557,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2531,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2015,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1876,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 980,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 617,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T00:00:00-05:00",
      "votes": 95
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 48738,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 37653,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 35498,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 24123,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 20357,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 17737,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 15823,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12371,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11608,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 8802,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 8481,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4427,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3383,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2600,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2565,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2021,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 1945,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T01:00:00-05:00",
      "votes": 980
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 619,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T01:00:00-05:00",
      "votes": 95
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 49094,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 37920,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 35825,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 24752,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 20535,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 18348,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 16157,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12395,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11662,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 8856,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 8525,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4542,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3385,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2601,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2567,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2097,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2058,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 983,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 629,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T02:00:00-05:00",
      "votes": 95
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 49563,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 38194,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 35884,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 24867,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 20621,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 18361,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 16262,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12425,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11669,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 8908,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 8614,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4742,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3386,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2602,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 2567
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2155,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2086,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 983
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 629
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 95
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 50106,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 38515,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 36206,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 25449,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 20710,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 18616,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 16478,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12443,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11672,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 8931,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 8652,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4828,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3387,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2604,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2575,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 2155
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2096,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 986,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 630,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 95
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 51048,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 38544,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 37292,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 25815,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 20981,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 18738,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 16568,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12473,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11697,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 8986,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 8665,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4878,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3401,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T05:00:00-05:00",
      "votes": 2604
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T05:00:00-05:00",
      "votes": 2575
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T05:00:00-05:00",
      "votes": 2155
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2098,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T05:00:00-05:00",
      "votes": 986
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 632,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T05:00:00-05:00",
      "votes": 95
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 51611,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 38666,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 38058,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 25952,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 21144,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 19164,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 16613,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12487,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11705,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 9057,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 8726,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4890,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3414,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2610,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2577,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2167,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2103,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 998,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 634,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T06:00:00-05:00",
      "votes": 95
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 52256,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 38917,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 38134,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 26540,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 21413,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 19743,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 16804,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12579,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11718,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 9261,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 8756,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4915,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3513,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2614,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2579,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2170,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2115,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1001,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 639,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 96,
      "timestamp": "2023-03-01T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 53071,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 39143,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 38488,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 26757,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 21829,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 20395,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 16954,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12669,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 11964,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 9447,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 8867,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 4979,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3586,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2735,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2600,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2190,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2132,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1005,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 644,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T08:00:00-05:00",
      "votes": 96
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 53847,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 40179,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 39080,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 26968,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 22313,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 20823,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 17049,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 12892,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 12104,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 9721,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 9262,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 5042,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3729,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2786,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2612,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2195,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2149,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1008,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 645,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 100,
      "timestamp": "2023-03-01T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 55068,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 41060,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 40392,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 27201,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 22737,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 21333,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 17100,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 13196,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 12121,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 9934,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 9566,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 5134,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3774,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2805,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2628,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2231,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2202,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1015,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 648,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T10:00:00-05:00",
      "votes": 100
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 56722,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 42055,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 41239,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 27622,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 23651,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 21934,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 17639,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 13555,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 12511,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 10150,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 9861,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 5216,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3839,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2849,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2679,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2359,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2245,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1017,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 655,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 101,
      "timestamp": "2023-03-01T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 57397,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 42610,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 41440,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 28034,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 24092,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 22062,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 18079,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 13815,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 12758,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 10507,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 9976,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 5320,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 3895,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 2962,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2822,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2402,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2271,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T12:00:00-05:00",
      "votes": 1017
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 666,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T12:00:00-05:00",
      "votes": 101
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 58481,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 43071,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 42447,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 28632,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 25044,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 22582,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 18376,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 13950,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 13748,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 10745,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 10126,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 5371,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 4003,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 3069,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 2863,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2437,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2297,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1019,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 678,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 102,
      "timestamp": "2023-03-01T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 59567,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 44268,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 43467,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 28818,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 26997,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 23476,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 18576,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 14857,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 14469,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 11146,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 10417,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 5719,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 4104,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 3215,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 3149,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2582,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2321,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1026,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 695,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T14:00:00-05:00",
      "votes": 102
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 60405,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 45041,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 44299,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 29256,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 28438,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 24294,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 18768,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 15398,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 14781,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 11670,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 10688,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 6129,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 4235,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 3749,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 3377,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 2807,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2468,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1030,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 701,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 105,
      "timestamp": "2023-03-01T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 61660,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 46053,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 45261,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 30227,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 29544,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 24528,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 18994,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 16115,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 15115,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 12244,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 10895,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 6398,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 4583,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 3939,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 3421,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3017,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2590,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1033,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 738,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 106,
      "timestamp": "2023-03-01T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 62532,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 46952,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 46188,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 31922,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 31013,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 25374,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 19180,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 16654,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 15304,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 12588,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 11487,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 6577,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 4661,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 4114,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 3502,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3164,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2662,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1035,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 743,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 108,
      "timestamp": "2023-03-01T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 64005,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 47780,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 47555,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 34274,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 32575,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 25678,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 19471,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 16986,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 15487,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 13070,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 12180,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 6790,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 4853,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 4239,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 3573,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3206,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2793,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1055,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 746,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 110,
      "timestamp": "2023-03-01T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 65074,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 49238,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 48239,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 35703,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 33568,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 26027,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 20066,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 17506,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 15716,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 13723,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 12393,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 7060,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 5201,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 4418,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 3619,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3221,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 2921,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1057,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 754,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 111,
      "timestamp": "2023-03-01T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 67784,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 50501,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 49300,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 37235,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 34312,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 27701,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 21076,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 18460,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 15845,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 14311,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 13041,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 7322,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 5502,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 4860,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 3659,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3300,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3245,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1060,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 787,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 113,
      "timestamp": "2023-03-01T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 69163,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 51849,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 51190,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 38818,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 35649,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 28334,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 21708,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 19075,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 15887,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 15119,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 13681,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 7520,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 5728,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 5237,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 3835,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3431,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3385,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1063,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 790,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 119,
      "timestamp": "2023-03-01T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 70380,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 53769,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 53359,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 39724,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 36282,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 29552,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 22555,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 19929,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 15941,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 15781,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 13946,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 7889,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 6049,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 5538,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4050,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3645,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3535,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1070,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 802,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T22:00:00-05:00",
      "votes": 119
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 72131,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 55992,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 54603,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 40508,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 37421,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 30947,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 22857,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 20538,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 16354,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 15969,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14157,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8053,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 6366,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 5872,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4180,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3749,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3573,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1077,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 805,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 134,
      "timestamp": "2023-03-01T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 73154,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 56816,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 55240,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 41141,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 38441,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 31011,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 23095,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 20793,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 16549,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16002,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14177,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8155,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 6763,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 6188,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4182,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 3929,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3703,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1078,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 809,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T00:00:00-05:00",
      "votes": 134
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 74682,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 57288,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 55656,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 41366,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 39011,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 31478,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 23537,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 21010,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 16616,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16016,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14219,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8216,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 7039,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 6457,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4189,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4074,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3710,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T01:00:00-05:00",
      "votes": 1078
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 814,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T01:00:00-05:00",
      "votes": 134
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 75143,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 57841,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 56503,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 41601,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 39128,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 32308,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 23608,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 21123,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 16726,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16166,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14285,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8250,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 7110,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 6781,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4263,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4190,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T02:00:00-05:00",
      "votes": 3710
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T02:00:00-05:00",
      "votes": 1078
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 820,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T02:00:00-05:00",
      "votes": 134
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 75477,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 58010,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 57368,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 41947,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 39257,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 32613,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 23690,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 21193,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 16770,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16171,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14315,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8256,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 7254,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 6870,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4320,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4192,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3716,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1079,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T03:00:00-05:00",
      "votes": 820
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T03:00:00-05:00",
      "votes": 134
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 76334,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 58096,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 57565,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 42271,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 39793,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 32903,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 24229,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 21256,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 16798,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16180,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14318,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8265,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 7415,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 6872,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4327,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4195,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3720,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T04:00:00-05:00",
      "votes": 1079
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T04:00:00-05:00",
      "votes": 820
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T04:00:00-05:00",
      "votes": 134
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 77222,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 58859,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 57860,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 42570,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 40945,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T05:00:00-05:00",
      "votes": 32903
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 24865,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 21352,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 16843,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16191,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14335,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8272,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 7564,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 6941,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4331,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4197,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3723,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1081,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T05:00:00-05:00",
      "votes": 820
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T05:00:00-05:00",
      "votes": 134
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 77700,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 59091,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 58087,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 43119,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 41864,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 32917,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 24914,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 21510,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 17062,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16199,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14459,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8287,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 7684,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 7251,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4392,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4219,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3730,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1084,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 821,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 135,
      "timestamp": "2023-03-02T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 78773,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 59831,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 58695,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 43440,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 42262,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 33245,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 25163,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 21662,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 17306,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16201,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14523,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8403,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 8092,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 7495,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4459,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4246,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3748,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1090,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 834,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 138,
      "timestamp": "2023-03-02T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 80426,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 60978,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 59511,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 44058,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 42755,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 34447,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 25220,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 22274,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 17502,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16221,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14599,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 8545,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8479,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 7667,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4474,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4253,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3759,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1099,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 839,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 139,
      "timestamp": "2023-03-02T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 81731,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 62233,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 60196,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 44672,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 43729,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 35728,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 25390,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 22994,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 17818,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16391,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 14671,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 8893,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8647,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 7776,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4513,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4278,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3900,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1106,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 841,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T09:00:00-05:00",
      "votes": 139
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 82710,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 62903,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 61221,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 45570,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 44015,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 35826,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 25687,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 23421,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 18472,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16541,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 15086,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 9440,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 8849,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 8054,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4552,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4376,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 3987,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1126,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 848,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 140,
      "timestamp": "2023-03-02T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 84042,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 64222,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 61917,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 46841,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 44504,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 36192,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 26149,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 24040,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 19119,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16702,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 15333,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 9584,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 9224,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 8162,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4646,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4484,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4019,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1137,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 851,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T11:00:00-05:00",
      "votes": 140
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 84828,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 65068,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 62736,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 48118,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 45142,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 37027,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 26446,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 24524,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 19643,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16830,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 15497,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 10286,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 10087,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 8338,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 4857,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4653,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4054,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1145,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 858,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 146,
      "timestamp": "2023-03-02T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 85638,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 65964,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 63279,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 49500,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 45783,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 38191,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 26731,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 25165,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 20332,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 16857,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 15653,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 10634,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 10364,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 8796,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5015,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4677,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4135,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1158,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 865,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 147,
      "timestamp": "2023-03-02T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 86307,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 66678,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 64137,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 51598,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 46142,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 38774,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 27172,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 25500,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 20683,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 17549,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 15816,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 11294,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 10697,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 9206,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5125,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4772,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4185,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1249,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 880,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 156,
      "timestamp": "2023-03-02T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 87645,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 67718,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 64763,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 52611,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 46615,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 39057,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 27402,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 27363,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 21157,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 17713,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 16044,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 11779,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 11056,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 9573,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5163,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4862,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4241,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1257,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 890,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T15:00:00-05:00",
      "votes": 156
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 88345,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 68769,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 65945,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 52984,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 46941,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 39526,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 28032,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 27729,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 21748,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 18188,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 16423,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 11870,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 11411,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 10041,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5344,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4879,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4256,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1262,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 900,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 157,
      "timestamp": "2023-03-02T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 90221,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 69399,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 66880,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 53723,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 47909,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 40128,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 28836,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 28358,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 22176,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 18639,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 16849,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 12420,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 11711,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 10351,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5521,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4891,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4420,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1269,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 903,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-02T17:00:00-05:00",
      "votes": 157
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 91508,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 70379,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 68433,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 54889,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 48552,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 40401,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 29572,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 28821,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 22690,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 18948,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 17326,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 13052,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 12503,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 10628,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5533,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 4979,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4445,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1320,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 906,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 158,
      "timestamp": "2023-03-02T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 92742,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 71598,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 69181,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 56431,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 49517,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 41428,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 30040,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 29851,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 23165,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 19245,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 17635,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 13597,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 12817,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 11091,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5573,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5082,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4478,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1326,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 913,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 160,
      "timestamp": "2023-03-02T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 94456,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 73348,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 70208,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 57675,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 50813,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 42678,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 30895,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 30834,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 23576,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 19867,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 17908,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 13781,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 13091,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 11383,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5621,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5110,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 4895,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1329,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 922,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 187,
      "timestamp": "2023-03-02T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 96347,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 75712,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 71750,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 59725,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 52119,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 43179,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 31960,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 31269,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 24128,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 20167,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 18385,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 14290,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 13400,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 11489,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5679,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5191,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5021,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1332,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 929,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 234,
      "timestamp": "2023-03-02T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 97442,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 76155,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 72968,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 60637,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 53209,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 43729,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 32546,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 31616,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 24641,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 20279,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 18813,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 14679,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 13646,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 11686,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5873,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5271,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5261,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1405,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 950,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 237,
      "timestamp": "2023-03-02T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 99338,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 77682,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 74105,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 61213,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 54375,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 45147,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 32878,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 32077,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 24951,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 20491,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19113,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 15360,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 13731,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 12353,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 5926,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5384,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5278,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1510,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 953,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 238,
      "timestamp": "2023-03-02T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 100350,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 78524,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 74645,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 61510,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 55025,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 46084,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 33174,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 32410,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 25044,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 20678,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19296,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 15586,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 13936,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 12794,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6052,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5430,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5287,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1558,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 961,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T00:00:00-05:00",
      "votes": 238
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 100724,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 78899,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 75229,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 61653,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 56195,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 46274,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 33301,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 32533,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 25118,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 20732,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19393,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 15833,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14023,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 12832,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6100,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5447,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5295,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1587,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 975,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T01:00:00-05:00",
      "votes": 238
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 100922,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 78913,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 75374,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 61776,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 56520,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 46549,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 33362,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 32594,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 25230,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 20744,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19395,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16229,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14042,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 12873,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6247,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T02:00:00-05:00",
      "votes": 5447
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5334,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1632,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T02:00:00-05:00",
      "votes": 975
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T02:00:00-05:00",
      "votes": 238
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 101492,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 78942,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 75923,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 61877,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 57034,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 46893,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 33415,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 32610,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 25248,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 20773,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19466,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16246,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-03T03:00:00-05:00",
      "votes": 14042
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 13015,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6452,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T03:00:00-05:00",
      "votes": 5447
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5345,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1633,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 977,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T03:00:00-05:00",
      "votes": 238
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 101754,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 79287,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 76058,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 61976,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 57491,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 46917,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 33553,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 32735,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 25260,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 20823,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19484,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16290,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14053,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 13038,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-03T04:00:00-05:00",
      "votes": 6452
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5450,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5357,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T04:00:00-05:00",
      "votes": 1633
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T04:00:00-05:00",
      "votes": 977
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T04:00:00-05:00",
      "votes": 238
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 102033,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 79914,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 76116,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 62511,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 57660,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 47012,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 33694,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 33137,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 25363,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 21049,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19561,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16296,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14079,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 13122,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6468,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5554,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5362,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1634,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 979,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 239,
      "timestamp": "2023-03-03T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 102636,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 80322,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 76211,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 63064,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 58385,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 47529,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 34045,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 33702,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 25507,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 21115,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19680,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16304,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14082,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 13529,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6497,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5648,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5365,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1635,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 981,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T06:00:00-05:00",
      "votes": 239
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 103326,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 81133,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 76804,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 63498,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 58721,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 47810,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 34206,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 33877,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 25922,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 21119,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19698,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16378,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14158,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 13636,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6572,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5651,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5441,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1638,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 985,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T07:00:00-05:00",
      "votes": 239
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 104484,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 81897,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 78395,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 63962,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 58990,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 48688,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 34550,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 34287,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 26130,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 21183,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19775,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16461,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14186,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 13709,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6586,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5707,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5464,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1642,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 993,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 240,
      "timestamp": "2023-03-03T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 105703,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 82556,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 78950,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 64584,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 59344,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 49853,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 35114,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 35065,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 26381,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 21339,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19817,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16604,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14329,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 13767,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6653,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5786,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5482,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1646,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1012,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 242,
      "timestamp": "2023-03-03T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 107145,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 84069,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 79305,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 65581,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 59745,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 50594,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 35714,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 35686,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 26710,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 21453,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 19956,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16668,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14568,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 14323,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6682,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5832,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5497,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1688,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1033,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T10:00:00-05:00",
      "votes": 242
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 108232,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 84641,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 80165,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 66667,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 60800,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 51250,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 36438,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 36127,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 27347,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 21517,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 20048,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 16823,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 14777,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14685,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6698,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5882,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5599,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1718,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1048,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 243,
      "timestamp": "2023-03-03T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 108881,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 85480,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 81097,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 67524,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 61880,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 52500,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 36839,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 36570,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 28070,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 21926,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 20154,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 17131,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 15040,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 14949,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6745,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 5951,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5630,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1729,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1067,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 246,
      "timestamp": "2023-03-03T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 110281,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 85712,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 82253,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 68110,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 62214,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 53050,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 37445,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 37425,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 28633,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 22416,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 20282,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 17518,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 15285,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 15209,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6755,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 6141,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5642,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1733,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1109,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 247,
      "timestamp": "2023-03-03T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 111367,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 86481,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 83069,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 68692,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 63551,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 53443,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 37912,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 37909,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 29136,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 22729,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 20696,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 17979,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 15856,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 15338,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6799,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 6299,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5656,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 1977,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1124,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 249,
      "timestamp": "2023-03-03T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 112208,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 87393,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 83729,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 69455,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 63971,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 54283,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 38675,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 38449,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 29516,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 23123,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 20971,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 18307,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 16361,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 15860,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6876,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 6489,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5676,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2003,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1132,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 253,
      "timestamp": "2023-03-03T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 113170,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 88081,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 84635,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 70268,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 64481,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 54465,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 39379,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 38784,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 30055,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 23183,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 21117,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 18435,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 16636,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 15971,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 6931,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 6685,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5722,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2037,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1137,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 255,
      "timestamp": "2023-03-03T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 114831,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 88696,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 85217,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 70933,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 65810,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 54541,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 39891,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 39275,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 30498,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 23290,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 21541,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 18510,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 16829,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16006,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7004,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 6735,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5739,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2041,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1141,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 256,
      "timestamp": "2023-03-03T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 115746,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 89202,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 85753,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 71591,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 66599,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 54618,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 40266,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 39582,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 31045,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 23412,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 22010,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 18681,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 17134,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16150,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7083,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 6782,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5780,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2044,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1144,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 258,
      "timestamp": "2023-03-03T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 116824,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 90478,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 86641,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 72166,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 67390,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 55553,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 40626,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 40156,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 31609,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 24208,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 22154,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 18807,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 17274,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16196,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7243,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 6831,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 5916,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2259,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1158,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 261,
      "timestamp": "2023-03-03T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 117850,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 92994,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 87577,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 73014,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 68955,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 55865,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 41269,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 41173,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 31969,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 24305,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 22331,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 19079,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 17595,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16325,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7306,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 6959,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 6093,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2268,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1159,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 262,
      "timestamp": "2023-03-03T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 118759,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 94361,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 88942,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 73771,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 69475,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 56389,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 42190,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 42146,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 32513,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 24767,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 23442,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 19358,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 17798,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16407,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7407,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 7133,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 6299,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2273,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1167,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 270,
      "timestamp": "2023-03-03T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 120951,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 95769,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 89962,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 75343,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 70485,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 57758,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 43532,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 43114,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 32964,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 25070,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 23836,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 19721,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 18175,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16619,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 7585,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7583,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 6413,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2282,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1191,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 273,
      "timestamp": "2023-03-03T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 123571,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 97225,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 91354,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 77212,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 71782,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 58645,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 44347,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 43572,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 33252,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 25370,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24061,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 19888,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 18267,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16714,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 7721,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7658,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 6588,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2292,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1202,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-03T23:00:00-05:00",
      "votes": 273
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 124545,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 97463,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 91898,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 78061,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 72504,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 58717,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 44864,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 44001,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 33493,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 25987,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24120,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20070,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 18292,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16755,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 7847,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7665,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 6778,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2303,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1209,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 282,
      "timestamp": "2023-03-04T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 125408,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 98059,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 92145,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 78527,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 73033,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 59951,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 45172,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 44153,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 33559,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26335,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24140,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20131,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 18306,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16870,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 7863,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7668,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 6782,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2311,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T01:00:00-05:00",
      "votes": 1209
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T01:00:00-05:00",
      "votes": 282
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 125845,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 98415,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 92294,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 78753,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 73251,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 61317,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 45425,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 44238,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 33577,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26378,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24164,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20212,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 18409,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16879,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 7866,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7748,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 6812,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T02:00:00-05:00",
      "votes": 2311
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1210,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T02:00:00-05:00",
      "votes": 282
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 125910,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 98560,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 92472,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 79052,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 73720,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 61424,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 45476,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 44739,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 33628,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26384,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24210,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20267,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 18727,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 16879
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 7866
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7824,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 6976,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 2311
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1211,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 282
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 126741,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 98959,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 92837,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 79315,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 74395,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 61466,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 45585,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 44847,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 33783,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26385,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24225,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20320,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 18740,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16881,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 7923,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 7872,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7081,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2318,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1214,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T04:00:00-05:00",
      "votes": 282
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 127276,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 99341,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 93035,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 79525,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 74775,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 61493,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 45704,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 44957,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 34018,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26409,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24239,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20324,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 18776,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16886,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 8058,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8003,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7215,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2319,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1217,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T05:00:00-05:00",
      "votes": 282
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 128057,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 99514,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 93338,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 79641,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 75655,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T06:00:00-05:00",
      "votes": 61493
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 45895,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 45153,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 34164,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26415,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24318,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20343,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 18826,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16894,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 8217,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8007,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7255,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T06:00:00-05:00",
      "votes": 2319
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1218,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T06:00:00-05:00",
      "votes": 282
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 128580,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 100474,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 93471,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 80040,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 76220,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 61599,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 46051,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 45402,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 34492,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26430,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24454,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20363,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 19078,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16910,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 8264,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8041,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7338,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T07:00:00-05:00",
      "votes": 2319
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1220,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T07:00:00-05:00",
      "votes": 282
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 129581,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 101181,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 94247,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 80536,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 76994,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 61995,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 46589,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 46102,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 34890,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26480,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24539,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20443,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 19456,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 16946,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 8326,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8049,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7351,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2321,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1233,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T08:00:00-05:00",
      "votes": 282
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 131247,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 102482,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 94689,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 80757,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 77606,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 63374,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 47023,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 46687,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 35370,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26636,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24704,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20497,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 19860,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17011,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 8417,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8086,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7387,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2324,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1343,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 284,
      "timestamp": "2023-03-04T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 132463,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 103097,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 95151,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 81069,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 78446,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 64857,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 47286,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 46999,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 35634,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 26874,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 24854,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20598,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 20203,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17054,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 8581,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8172,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7509,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T10:00:00-05:00",
      "votes": 2324
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1397,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 286,
      "timestamp": "2023-03-04T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 133694,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 103411,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 95442,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 81367,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 79002,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 65058,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 48079,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 47504,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 35993,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 27319,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 25245,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20738,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 20565,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17081,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 8902,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8210,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7535,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2333,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1420,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 287,
      "timestamp": "2023-03-04T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 134155,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 105292,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 96074,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 81819,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 79907,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 65353,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 48496,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 48053,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 36222,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 27373,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 25374,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 20888,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 20876,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17093,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 9063,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8262,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7579,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2338,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1499,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 288,
      "timestamp": "2023-03-04T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 136033,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 106641,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 96951,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 82253,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 80385,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 65775,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 48894,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 48719,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 36460,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 27693,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 25479,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 21390,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 21252,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17108,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 9115,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8298,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7617,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2341,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1566,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T13:00:00-05:00",
      "votes": 288
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 137609,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 108906,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 97647,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 83452,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 80867,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 66503,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 49491,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 49347,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 36723,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 28037,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 25919,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 21909,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 21327,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17159,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 9163,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8326,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7645,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2345,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1591,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 290,
      "timestamp": "2023-03-04T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 138488,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 109607,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 98101,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 84410,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 81250,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 67184,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 50217,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 49590,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 37049,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 28073,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 26294,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 22201,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 21388,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17340,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 9312,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8362,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7656,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2346,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1667,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 291,
      "timestamp": "2023-03-04T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 140157,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 110186,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 98834,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 84953,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 81821,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 67772,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 50691,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 49866,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 37318,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 28117,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 26474,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 22317,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 21494,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17730,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 9413,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8453,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7671,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2351,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1677,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T16:00:00-05:00",
      "votes": 291
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 142201,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 112188,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 99536,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 85669,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 82555,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 69040,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 51073,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 50223,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 37930,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 28587,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 26551,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 22477,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 21568,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17756,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 9495,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8517,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7699,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2356,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1718,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T17:00:00-05:00",
      "votes": 291
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 142871,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 112797,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 100158,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 86372,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 83249,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 69629,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 51501,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 50899,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 38461,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 28637,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 26741,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 22649,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 21657,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17821,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 9618,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8601,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7704,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2361,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1725,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T18:00:00-05:00",
      "votes": 291
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 144174,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 113690,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 101144,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 86725,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 83719,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 70596,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 52045,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 51453,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 39353,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 28973,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 27305,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 22915,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 21744,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 17898,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 9772,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8633,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7751,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2364,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1737,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 309,
      "timestamp": "2023-03-04T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 146233,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 115274,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 102220,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 87268,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 84794,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 71939,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 52511,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 52240,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 40057,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 29912,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 27837,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 23323,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22127,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18023,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 9931,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8679,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7822,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2369,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1757,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 310,
      "timestamp": "2023-03-04T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 147713,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 116599,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 103810,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 88562,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 86182,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 72638,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 53099,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 52955,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 40484,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 30409,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 28342,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 23617,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22187,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18146,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10224,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8713,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 7842,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2373,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1767,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 311,
      "timestamp": "2023-03-04T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 149313,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 117267,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 105422,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 89645,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 87369,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 73667,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 53841,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 53555,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 41153,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 30768,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 28624,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 23833,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22277,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18235,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10344,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8730,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8139,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2375,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1823,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 312,
      "timestamp": "2023-03-04T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 150878,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 118438,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 106553,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 91329,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 88154,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 75031,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 54451,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 53790,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 41273,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31061,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29079,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24037,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22346,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18325,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10521,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8795,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8269,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2377,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1859,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 314,
      "timestamp": "2023-03-04T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 152191,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 120114,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 107466,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 92573,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 88400,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 75464,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 54776,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 54032,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 41478,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31300,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29129,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24097,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22400,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18360,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10542,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8890,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8284,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2378,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1922,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 315,
      "timestamp": "2023-03-05T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 152624,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 120730,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 107726,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 93153,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 88766,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 75690,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 54861,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 54236,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 41550,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31550,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29147,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24230,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22410,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18664,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10594,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 8946,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8285,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T01:00:00-05:00",
      "votes": 2378
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 1946,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 317,
      "timestamp": "2023-03-05T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 153721,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 120824,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 107828,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 93280,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 88897,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 76268,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 54938,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 54446,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 41702,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31632,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29184,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24233,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22426,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18893,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T02:00:00-05:00",
      "votes": 10594
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9002,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8293,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T02:00:00-05:00",
      "votes": 2378
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2000,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T02:00:00-05:00",
      "votes": 317
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 154421,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 120917,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 107912,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 93376,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 89101,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 76504,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 55158,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 54548,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 41783,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31638,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29307,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24236,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22431,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18894,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T03:00:00-05:00",
      "votes": 10594
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9003,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8297,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T03:00:00-05:00",
      "votes": 2378
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2033,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T03:00:00-05:00",
      "votes": 317
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 154540,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 121073,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 108017,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 93389,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 89178,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 76510,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 55361,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 54704,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 41888,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31737,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29313,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24278,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22435,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18898,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10611,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-05T04:00:00-05:00",
      "votes": 9003
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T04:00:00-05:00",
      "votes": 8297
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T04:00:00-05:00",
      "votes": 2378
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2065,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 318,
      "timestamp": "2023-03-05T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 154711,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 121525,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 108060,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 93682,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 89642,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 76514,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 55445,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 54763,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 42101,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31753,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29318,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24294,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22439,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18899,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10612,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-05T05:00:00-05:00",
      "votes": 9003
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T05:00:00-05:00",
      "votes": 8297
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T05:00:00-05:00",
      "votes": 2378
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2086,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T05:00:00-05:00",
      "votes": 318
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 155048,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 121540,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 108072,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 93989,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 89838,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 76643,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 55598,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 54802,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 42350,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T06:00:00-05:00",
      "votes": 31753
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29320,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24475,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22446,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18901,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10725,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9004,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8304,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2380,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2148,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T06:00:00-05:00",
      "votes": 318
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 155400,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 122165,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 108240,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 94443,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 90389,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 76924,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 55756,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 54915,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 42584,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31807,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29383,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24738,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22503,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18944,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10777,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9008,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8316,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2384,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2339,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 320,
      "timestamp": "2023-03-05T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 156410,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 122781,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 108689,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 95064,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 90567,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 77852,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 56269,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 55462,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 42975,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31818,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29446,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24857,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22532,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18950,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10805,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9013,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8354,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2390,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2386,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 321,
      "timestamp": "2023-03-05T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 157175,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 123691,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 109215,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 95778,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 91208,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 78755,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 56867,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 56374,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 43127,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31831,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 29926,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 24962,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22602,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 18970,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10863,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9026,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8383,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2398,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2387,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 323,
      "timestamp": "2023-03-05T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 158131,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 124891,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 109458,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 96128,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 91474,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 79496,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 57155,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 57115,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 43380,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 31966,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 30262,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 25084,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22673,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 19071,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10909,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9105,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8477,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2434,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T10:00:00-05:00",
      "votes": 2387
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T10:00:00-05:00",
      "votes": 323
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 158955,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 125680,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 110068,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 96491,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 91718,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 80228,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 58163,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 57379,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 43582,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 32070,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 30361,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 25155,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22707,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 19115,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 10938,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9153,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8479,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2457,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2389,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 326,
      "timestamp": "2023-03-05T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 160150,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 126391,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 110754,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 96891,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 92004,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 81777,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 58582,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 57695,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 43912,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 32273,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 30739,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 25292,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22747,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 19133,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 11094,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9171,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8503,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2477,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2390,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T12:00:00-05:00",
      "votes": 326
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 161496,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 127394,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 111500,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 97464,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 92454,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 82662,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 58885,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 58262,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 44230,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 32502,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 31147,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 25425,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 22857,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 19345,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 11125,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9199,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8555,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2526,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2393,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T13:00:00-05:00",
      "votes": 326
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 162044,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 129324,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 111968,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 98016,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 92897,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 83120,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 59044,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 58457,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 44442,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 32692,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 31542,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 25660,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23047,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 19593,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 11202,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9209,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8610,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2580,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2402,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 329,
      "timestamp": "2023-03-05T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 163360,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 129897,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 112590,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 98723,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 93515,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 84233,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 59145,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 58904,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 44803,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 33006,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 32090,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 25842,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23067,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 20187,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 11289,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9324,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8637,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2586,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2403,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T15:00:00-05:00",
      "votes": 329
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 164899,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 131763,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 113595,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 99199,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 94042,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 85173,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 59641,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 59465,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 45228,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 33080,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 32415,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 26082,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23097,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 20478,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 11358,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9355,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8645,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2628,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2407,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 330,
      "timestamp": "2023-03-05T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 166280,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 132859,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 114378,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 99761,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 94555,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 86368,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 60350,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 60347,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 45862,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 33644,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 33183,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 26315,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23283,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 20738,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 11508,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9365,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8778,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2649,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2412,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 331,
      "timestamp": "2023-03-05T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 167619,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 135436,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 115350,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 100867,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 95465,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 87203,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 61575,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 61312,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 46277,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 34354,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 33559,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 26559,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23317,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 20910,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 11736,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9401,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8813,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2656,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2415,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T18:00:00-05:00",
      "votes": 331
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 169211,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 136686,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 116441,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 102059,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 95982,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 88040,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 62252,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 62042,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 46590,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 35122,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 34022,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 26760,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23338,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 21237,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 11772,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9442,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 8893,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2753,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2418,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 332,
      "timestamp": "2023-03-05T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 170421,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 137918,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 117534,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 102711,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 97105,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 88595,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 63074,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 62620,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 46994,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 35899,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 34253,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 27331,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23581,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 21467,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 11929,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9505,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9135,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2772,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2424,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 335,
      "timestamp": "2023-03-05T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 173346,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 141131,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 118235,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 103299,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 98396,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 91552,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 63817,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 63335,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 47309,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 36738,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 34535,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 27639,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23871,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 21875,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12121,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9548,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9260,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2797,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2430,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 337,
      "timestamp": "2023-03-05T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 174639,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 143034,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 119251,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 104236,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 98987,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 92401,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 64358,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 63605,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 47593,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 37061,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 34916,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 27817,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23928,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22086,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12445,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9601,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9269,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2806,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2431,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T22:00:00-05:00",
      "votes": 337
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 175461,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 144095,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 119968,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 105439,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 99831,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 93000,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 64628,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 64326,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 47922,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 37536,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 35898,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 28092,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 23950,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22181,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12663,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9608,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9356,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2814,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2586,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T23:00:00-05:00",
      "votes": 337
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 177566,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 145312,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 120367,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 105967,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 100154,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 94333,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 64823,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 64720,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 48115,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 37811,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 36663,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 28138,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24039,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22335,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12682,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9643,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9439,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2869,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2862,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 340,
      "timestamp": "2023-03-06T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 179155,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 145766,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 121102,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 106336,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 100579,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 95805,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 65136,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 64960,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 48136,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 37946,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 37301,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 28177,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24047,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22428,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T01:00:00-05:00",
      "votes": 12682
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9736,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9495,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2938,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2876,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T01:00:00-05:00",
      "votes": 340
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 179319,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 146251,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 121442,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 106407,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 100759,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 96038,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 65513,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 65018,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 48233,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 38391,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 37615,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 28233,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24060,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22430,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12686,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9829,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9497,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2953,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2881,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T02:00:00-05:00",
      "votes": 340
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 179756,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 146785,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 121467,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 106437,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 101015,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 96316,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 65831,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 65052,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 48268,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 38551,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 37916,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 28500,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T03:00:00-05:00",
      "votes": 24060
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22440,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12689,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 9897,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9503,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T03:00:00-05:00",
      "votes": 2953
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2912,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T03:00:00-05:00",
      "votes": 340
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 180100,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 146904,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 121585,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 106724,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 101019,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 96554,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 66029,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 65171,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 48300,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 38647,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 37919,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 28708,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T04:00:00-05:00",
      "votes": 24060
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22441,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12690,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10012,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9530,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T04:00:00-05:00",
      "votes": 2953
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2915,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T04:00:00-05:00",
      "votes": 340
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 180786,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 147470,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 121600,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 106777,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 101180,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 96735,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 66172,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 65361,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 48393,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 38816,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T05:00:00-05:00",
      "votes": 37919
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 29016,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24062,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22443,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12692,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-06T05:00:00-05:00",
      "votes": 10012
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9554,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T05:00:00-05:00",
      "votes": 2953
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2926,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T05:00:00-05:00",
      "votes": 340
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 181478,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 148493,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 121699,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 106960,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 101580,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 97087,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 66248,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 65665,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 48509,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 39174,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 37921,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 29111,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24077,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22518,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12755,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10016,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9582,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2957,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2954,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 345,
      "timestamp": "2023-03-06T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 182007,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 148682,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 121921,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 107141,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 101952,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 97492,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 66786,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 65711,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 48909,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 39305,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 37938,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 29360,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24096,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22694,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12810,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10021,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9640,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 2961,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T07:00:00-05:00",
      "votes": 2954
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T07:00:00-05:00",
      "votes": 345
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 183722,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 149486,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 122138,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 107587,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 102346,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 98321,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 67066,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 65967,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 49562,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 39475,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 38302,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 29595,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24128,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 22886,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 12981,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10029,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 9873,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 3057,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2957,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 347,
      "timestamp": "2023-03-06T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 184778,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 150196,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 122688,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 107787,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 102895,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 98733,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 67307,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 66356,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 50098,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 39703,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 38714,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 29857,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24158,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 23069,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 13180,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 10235,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10034,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 3237,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2960,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 350,
      "timestamp": "2023-03-06T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 185787,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 151834,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 123079,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 108203,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 103301,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 100237,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 67563,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 67497,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 50565,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 40323,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 39465,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 30117,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24220,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 23248,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 13232,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 10447,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10037,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 3336,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2963,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T10:00:00-05:00",
      "votes": 350
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 186538,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 152456,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 123639,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 108741,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 103843,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 100785,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 68330,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 68189,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 51147,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 40585,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 39952,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 30550,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24242,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 23453,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 13596,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 10528,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10066,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 3460,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2971,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T11:00:00-05:00",
      "votes": 350
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 186872,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 152990,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 124085,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 109144,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 104655,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 101461,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 68988,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 68367,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 51499,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 41120,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 40893,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 30650,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24279,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 23601,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 13717,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 10800,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10112,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 3558,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2977,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 353,
      "timestamp": "2023-03-06T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 188258,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 154073,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 124963,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 109898,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 105380,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 103816,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 69564,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 69161,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 52006,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 42272,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 42014,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 30924,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24344,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 23761,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 13774,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 10945,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10142,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 3634,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2978,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 354,
      "timestamp": "2023-03-06T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 189330,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 155102,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 125485,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 110288,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 105974,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 104954,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 69846,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 69606,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 52756,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 42654,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 42400,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 31084,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24390,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 23826,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 14003,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 11133,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10193,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 3818,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2983,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 355,
      "timestamp": "2023-03-06T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 190311,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 157311,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 125778,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 110848,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 107720,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 105619,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 70401,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 69962,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 53358,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 43257,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 42832,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 31440,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24455,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 24085,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 14217,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 11300,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10210,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 3967,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 2992,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 357,
      "timestamp": "2023-03-06T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 192300,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 157889,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 126709,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 111819,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 108576,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 107082,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 71059,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 70277,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 54080,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 43896,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 43331,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 31709,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24512,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 24388,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 14358,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 11561,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10226,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4148,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3038,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T16:00:00-05:00",
      "votes": 357
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 193746,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 158988,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 127746,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 112497,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 109506,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 108235,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 71434,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 70588,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 54681,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 44428,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 44003,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 32010,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24565,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 24537,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 14447,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 11835,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10235,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4167,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3040,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T17:00:00-05:00",
      "votes": 357
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 195115,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 159968,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 128701,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 113279,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 111264,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 110100,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 71912,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 71180,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 55169,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 45112,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 44714,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 32358,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 25927,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24645,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 14511,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 12054,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10243,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4270,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3205,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 359,
      "timestamp": "2023-03-06T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 196883,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 162579,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 129263,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 115772,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 113289,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 112168,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 72343,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 71882,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 55741,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 45889,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 44959,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 32892,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 27739,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24721,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 14582,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 12269,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10252,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4358,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3220,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 361,
      "timestamp": "2023-03-06T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 199378,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 164814,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 130208,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 117719,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 115193,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 114895,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 73209,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 73005,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 56492,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 46728,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 45407,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 33131,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 29324,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24822,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 14705,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 12414,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10262,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4370,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3245,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 365,
      "timestamp": "2023-03-06T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 201853,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 166187,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 131208,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 120076,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 117847,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 116568,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 74165,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 73848,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 57523,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 48094,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 45607,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 33849,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 30128,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 24957,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15000,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 12709,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10302,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4381,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3281,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T21:00:00-05:00",
      "votes": 365
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 203324,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 166995,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 132237,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 122125,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 120040,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 117354,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 75170,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 75168,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 58265,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 48758,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 45726,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 34179,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 30372,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25049,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15236,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 12789,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10383,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4410,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3286,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 367,
      "timestamp": "2023-03-06T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 205416,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 167974,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 133488,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 123600,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 121045,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 119662,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 75855,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 75842,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 58760,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 49592,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 46297,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 34665,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 30687,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25113,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15322,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13035,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10501,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4425,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3289,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 369,
      "timestamp": "2023-03-06T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 207508,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 170723,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 133893,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 124313,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 121607,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 121468,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 76257,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 76135,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 59194,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 50068,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 46336,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 34837,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31015,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25125,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15327,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13090,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10607,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4434,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3366,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 372,
      "timestamp": "2023-03-07T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 208316,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 171353,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 134660,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 124613,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 123068,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 122519,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 76499,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 76301,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 59389,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 50481,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 46693,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 35035,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31042,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25177,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15328,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13128,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10805,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4435,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T01:00:00-05:00",
      "votes": 3366
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T01:00:00-05:00",
      "votes": 372
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 209100,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 171558,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 134980,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 124867,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 123908,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 123147,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 76738,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 76455,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 59515,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 50791,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 46804,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 35174,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31054,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25179,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15337,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13130,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 10927,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4441,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3496,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T02:00:00-05:00",
      "votes": 372
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 209230,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 171743,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 135173,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 125474,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 124150,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 123186,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 77033,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 76471,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 59655,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 51042,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 46808,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 35176,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31055,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25180,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15344,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13134,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11010,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4442,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T03:00:00-05:00",
      "votes": 3496
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T03:00:00-05:00",
      "votes": 372
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 210276,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 171925,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 135460,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 126299,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 124910,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 123340,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 77498,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 76484,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 59725,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 51630,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 46822,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 35284,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31062,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25183,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T04:00:00-05:00",
      "votes": 15344
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T04:00:00-05:00",
      "votes": 13134
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11012,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4454,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T04:00:00-05:00",
      "votes": 3496
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T04:00:00-05:00",
      "votes": 372
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 210861,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 172143,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 135487,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 126871,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 125131,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 124016,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 77680,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 76530,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 60025,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 51698,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 46992,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 35460,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31069,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25190,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15371,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13145,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-07T05:00:00-05:00",
      "votes": 11012
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4562,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3497,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T05:00:00-05:00",
      "votes": 372
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 211324,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 173108,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 135717,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 127720,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 125376,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 124414,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 77798,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 76702,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 60208,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 51996,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 46993,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 35636,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31136,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25199,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15464,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13314,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11018,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4574,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3499,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T06:00:00-05:00",
      "votes": 372
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 212477,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 173559,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 135824,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 128407,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 126373,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 125386,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 78207,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 77146,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 60621,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 52435,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 47211,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 35667,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31201,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25238,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15542,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13334,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11025,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4592,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3501,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T07:00:00-05:00",
      "votes": 372
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 214575,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 174553,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 136247,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 129119,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 128331,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 126369,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 78723,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 77320,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 61194,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 53027,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 47595,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 35939,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31230,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25430,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15671,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13569,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11036,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4627,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3503,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 373,
      "timestamp": "2023-03-07T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 215136,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 175668,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 137249,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 131357,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 129759,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 126713,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 79357,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 77613,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 61725,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 53569,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 48080,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 36140,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31297,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25452,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 15919,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13636,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11066,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4647,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3526,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 374,
      "timestamp": "2023-03-07T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 215875,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 176936,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 138065,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 132602,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 130609,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 127529,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 80130,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 78559,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 62065,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 54424,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 48718,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 36238,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31357,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25510,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16071,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13769,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11127,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4654,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3536,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 375,
      "timestamp": "2023-03-07T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 217367,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 177477,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 139101,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 133245,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 132269,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 128659,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 80490,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 79321,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 62559,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 54925,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 48997,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 36679,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31430,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25526,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16315,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 13932,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11196,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4664,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3544,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 376,
      "timestamp": "2023-03-07T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 218718,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 178925,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 140099,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 134701,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 133373,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 129036,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 81429,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 79775,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 63021,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 55342,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 49053,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 36824,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 31678,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25559,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16341,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 14180,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11296,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4670,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3548,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 378,
      "timestamp": "2023-03-07T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 220646,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 179831,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 140612,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 136559,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 135238,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 129875,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 82351,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 80136,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 63399,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 55864,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 49363,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 37079,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 32039,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25596,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16379,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 14217,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11315,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4692,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3552,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 381,
      "timestamp": "2023-03-07T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 221486,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 181442,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 141150,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 138432,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 136027,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 130374,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 83035,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 80668,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 64156,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 56229,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 50025,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 37209,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 32146,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25702,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16412,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 14289,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11323,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4721,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3576,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 382,
      "timestamp": "2023-03-07T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 222385,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 182673,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 141864,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 139737,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 137830,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 131221,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 83529,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 80998,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 64668,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 57555,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 50281,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 37404,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 32328,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25800,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16470,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 14475,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11329,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4730,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3601,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T15:00:00-05:00",
      "votes": 382
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 224469,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 184076,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 142514,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 142320,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 139131,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 132130,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 84259,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 81530,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 65164,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 58356,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 50477,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 37638,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 32423,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25878,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16572,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 14675,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11341,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4762,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3612,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 383,
      "timestamp": "2023-03-07T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 225775,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 184606,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 144174,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 143095,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 139851,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 133669,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 84859,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 81851,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 65783,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 59028,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 50579,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 38155,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 32668,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 25912,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16672,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 14784,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11371,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4768,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3617,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 384,
      "timestamp": "2023-03-07T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 227803,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 185633,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 145651,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 144229,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 141510,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 134861,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 85373,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 82292,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 66594,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 59647,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 50940,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 38714,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 32837,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 26116,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16866,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 14931,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11383,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4820,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3678,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 388,
      "timestamp": "2023-03-07T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 229806,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 187537,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 147474,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 144931,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 142775,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 135822,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 85802,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 82962,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 67519,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 60718,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 51382,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 39203,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 33008,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 26436,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 16942,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 15104,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11389,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 4963,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3761,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T19:00:00-05:00",
      "votes": 388
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 231539,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 189012,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 149704,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 146292,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 143646,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 137762,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 86510,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 83492,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 68537,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 61781,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 52285,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 39620,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 33106,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 26615,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17232,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 15191,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11537,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5015,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3779,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-07T20:00:00-05:00",
      "votes": 388
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 233881,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 190254,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 151023,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 147847,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 146102,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 140040,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 87437,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 84092,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 69285,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 63086,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53006,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 40171,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 33330,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 26756,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17442,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 15320,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11624,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5073,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3798,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 389,
      "timestamp": "2023-03-07T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 236640,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 192144,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 151988,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 149001,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 148131,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 141419,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 88487,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 84730,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 69814,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 63560,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53322,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 40520,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 33510,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27010,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17499,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 15524,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11650,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5088,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3807,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 396,
      "timestamp": "2023-03-07T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 237532,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 194210,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 153187,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 150181,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 149412,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 142220,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 89005,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 85223,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 70362,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 63883,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53372,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41177,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 33648,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27126,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17507,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 15614,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11660,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5111,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3809,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 398,
      "timestamp": "2023-03-07T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 239097,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 194827,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 153728,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 151733,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 151432,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 142904,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 89282,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 85474,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 70592,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 64136,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53453,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41219,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 33929,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27153,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17551,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 15948,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11693,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5133,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3810,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T00:00:00-05:00",
      "votes": 398
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 240313,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 195063,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 154344,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 152521,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 152304,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 143502,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 89689,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 85515,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 70748,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 64165,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53497,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41229,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 33974,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27176,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17588,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 15951,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11702,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5148,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T01:00:00-05:00",
      "votes": 3810
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 400,
      "timestamp": "2023-03-08T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 240582,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 195490,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 154564,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 153291,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 152364,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 143897,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 89812,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 85541,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 70826,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 64205,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53615,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41255,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34058,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27186,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17619,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16000,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11773,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5159,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T02:00:00-05:00",
      "votes": 3810
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T02:00:00-05:00",
      "votes": 400
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 241205,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 195503,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 154656,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 153837,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 152535,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 144106,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 89911,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 85670,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 70860,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 64238,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53624,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41309,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34071,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27270,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17620,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16003,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11810,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5173,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T03:00:00-05:00",
      "votes": 3810
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 401,
      "timestamp": "2023-03-08T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 241597,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 195560,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 155425,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 154111,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 153162,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 144706,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 90090,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 85942,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 71051,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 64248,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53627,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41340,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34116,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27273,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T04:00:00-05:00",
      "votes": 17620
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16004,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-08T04:00:00-05:00",
      "votes": 11810
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5179,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3811,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T04:00:00-05:00",
      "votes": 401
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 242266,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 195609,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 156122,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 154191,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 153566,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 145262,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 90188,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 86077,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 71684,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 64351,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53628,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41381,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34253,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27278,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17672,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16052,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11811,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5180,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3813,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T05:00:00-05:00",
      "votes": 401
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 243157,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 196285,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 156694,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 154455,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 153922,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 146103,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 90684,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 86160,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 72110,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 64462,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53629,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41531,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34298,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27325,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17714,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16392,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11812,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5182,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3877,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 404,
      "timestamp": "2023-03-08T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 244347,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 197484,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 157528,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 155341,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 154646,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 146778,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 91327,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 86286,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 72475,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 64949,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53653,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41611,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34364,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27349,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17723,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16426,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11825,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5199,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3899,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T07:00:00-05:00",
      "votes": 404
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 246124,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 197893,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 158321,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 156690,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 156434,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 147520,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 91552,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 86624,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 72783,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 65204,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 53901,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41644,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34470,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27377,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17781,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16504,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11829,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5253,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3907,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 405,
      "timestamp": "2023-03-08T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 249209,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 199625,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 159811,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 159439,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 157415,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 148317,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 91749,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 87084,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 73156,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 65650,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 54044,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41709,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34505,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27405,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17899,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16568,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11841,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5290,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3909,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 407,
      "timestamp": "2023-03-08T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 250101,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 200457,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 162873,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 161314,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 158132,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 148669,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 92085,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 88148,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 73353,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 65935,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 54110,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41728,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 34654,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27503,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 17943,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16674,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11849,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5317,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3914,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T10:00:00-05:00",
      "votes": 407
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 252399,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 202064,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 163825,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 162758,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 158476,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 149092,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 93038,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 88569,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 73674,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 66721,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 54654,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 41951,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 35040,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27526,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 18061,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16781,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 11888,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5444,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 3939,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 409,
      "timestamp": "2023-03-08T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 253136,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 203043,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 165016,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 163880,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 158947,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 149530,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 93513,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 89198,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 74176,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 67284,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 55557,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 42217,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 35160,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27577,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 18100,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 16815,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12075,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5592,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4026,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 410,
      "timestamp": "2023-03-08T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 253832,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 204378,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 165587,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 164385,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 159858,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 149973,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 93946,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 89882,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 74502,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 67634,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 55955,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 42520,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 35379,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27612,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 18205,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 17091,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12119,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5606,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4096,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 411,
      "timestamp": "2023-03-08T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 254571,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 204863,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 167127,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 165033,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 161033,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 150518,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 94806,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 90448,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 75129,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 68145,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 56208,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 42778,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 35494,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27648,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 18326,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 17209,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12151,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5698,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4126,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 412,
      "timestamp": "2023-03-08T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 256675,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 206226,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 168688,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 166261,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 162080,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 150831,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 95324,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 91112,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 75467,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 68303,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 56738,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 43200,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 35589,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27693,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 18358,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 17247,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12166,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5762,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4153,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T15:00:00-05:00",
      "votes": 412
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 259060,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 207919,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 169705,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 168706,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 163299,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 151331,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 95986,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 91466,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 75841,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 68695,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 56795,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 43655,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 35683,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27717,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 18376,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 17474,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12172,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5775,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4158,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 415,
      "timestamp": "2023-03-08T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 260644,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 208450,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 170832,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 169441,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 163684,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 151928,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 96772,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 92131,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 76429,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 69079,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 56866,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 43939,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 35845,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27802,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 18518,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 17636,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12188,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5778,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4167,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 417,
      "timestamp": "2023-03-08T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 261850,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 209257,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 172381,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 170247,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 164379,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 152427,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 97195,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 92515,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 77000,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 69642,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 56885,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 44289,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 35948,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27840,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 18672,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 17723,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12328,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 5935,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4177,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T18:00:00-05:00",
      "votes": 417
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 263642,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 210608,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 174254,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 171867,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 165362,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 153071,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 97658,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 93178,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 77694,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 70331,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 56990,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 44624,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36096,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27887,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19048,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 17791,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12394,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6087,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4182,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 418,
      "timestamp": "2023-03-08T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 265163,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 211948,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 175639,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 172980,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 166144,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 154638,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 98730,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 93649,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 78387,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 71131,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 57252,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 45007,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36187,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 27954,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19198,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 17915,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12413,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6096,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4203,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 419,
      "timestamp": "2023-03-08T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 266715,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 213799,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 177541,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 174143,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 167650,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 156084,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 99228,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 94214,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 79214,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 71993,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 57704,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 45686,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36362,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28037,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19490,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 18254,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12421,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6104,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4240,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 420,
      "timestamp": "2023-03-08T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 268273,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 215546,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 179289,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 175992,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 168877,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 156916,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 99819,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 94531,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 80169,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 72668,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 58022,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 46247,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36508,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28067,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19621,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 18575,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12501,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6113,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4242,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-08T22:00:00-05:00",
      "votes": 420
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 270529,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 216547,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 180215,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 177876,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 170241,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 157998,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 100534,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 95139,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 80571,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 73113,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 58254,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 46476,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36573,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28083,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19639,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 18838,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12519,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6144,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4243,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 421,
      "timestamp": "2023-03-08T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 273433,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 217637,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 180975,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 180235,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 170944,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 158277,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 100826,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 95308,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 80758,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 73275,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 58476,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 46686,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36646,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28092,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19647,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19021,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12593,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6153,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4245,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T00:00:00-05:00",
      "votes": 421
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 274820,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 218050,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 182194,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 182175,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 171769,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 158771,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 101020,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 95455,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 81028,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 73879,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 58875,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 46697,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36652,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28099,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19649,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19056,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12623,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6168,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4246,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T01:00:00-05:00",
      "votes": 421
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 275889,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 218090,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 183754,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 182712,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 172082,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 158860,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 101322,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 95503,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 81145,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 73934,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 58879,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 46705,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36704,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28154,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T02:00:00-05:00",
      "votes": 19649
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19058,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12702,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6178,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4248,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 423,
      "timestamp": "2023-03-09T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 276797,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 218110,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 184263,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 183162,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 172323,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 158862,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 101362,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 95565,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 81196,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 73948,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 59208,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 46735,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36706,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28157,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19759,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T03:00:00-05:00",
      "votes": 19058
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12704,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6183,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T03:00:00-05:00",
      "votes": 4248
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T03:00:00-05:00",
      "votes": 423
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 277214,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 218515,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 184652,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 183477,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 172447,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 159489,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 101396,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 95569,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 81346,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 74124,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T04:00:00-05:00",
      "votes": 59208
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T04:00:00-05:00",
      "votes": 46735
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36708,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28163,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19791,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19156,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12705,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T04:00:00-05:00",
      "votes": 6183
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T04:00:00-05:00",
      "votes": 4248
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T04:00:00-05:00",
      "votes": 423
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 277369,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 218605,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 185237,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 183513,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 172548,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 160188,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 101513,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 95574,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 81764,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 74319,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 59210,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 46774,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36709,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28181,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19794,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19196,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-09T05:00:00-05:00",
      "votes": 12705
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6185,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4252,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T05:00:00-05:00",
      "votes": 423
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 278550,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 219107,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 185704,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 184305,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 172720,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 160647,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 101745,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 95606,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 81965,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 74386,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 59212,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 47133,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36718,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28189,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19813,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19316,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12709,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6188,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4254,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 428,
      "timestamp": "2023-03-09T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 279342,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 219363,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 186524,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 185230,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 172889,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 161486,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 102061,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 95852,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 82566,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 74750,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 59501,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 47544,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36766,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28282,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19903,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19340,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12715,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6229,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4258,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T07:00:00-05:00",
      "votes": 428
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 280445,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 220738,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 187468,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 186374,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 173264,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 161605,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 102370,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 96379,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 83096,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 75129,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 59515,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 47736,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36806,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28291,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 19951,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19416,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12723,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6233,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4260,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 429,
      "timestamp": "2023-03-09T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 281996,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 221541,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 188731,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 188050,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 174790,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 161979,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 102810,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 96623,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 83414,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 75526,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 59609,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 47927,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36859,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28307,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 20014,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19603,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12782,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6329,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4264,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T09:00:00-05:00",
      "votes": 429
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 285663,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 222890,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 191777,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 190802,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 175553,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 162632,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 103387,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 96955,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 83815,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 75739,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 60341,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 48247,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36877,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28346,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 20114,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19727,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12795,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6470,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4268,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 430,
      "timestamp": "2023-03-09T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 286465,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 224351,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 192386,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 191222,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 176536,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 163109,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 104297,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 97384,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 84454,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 76690,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 61081,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 48387,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36908,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28371,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 20256,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 19952,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12816,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6560,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4275,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 443,
      "timestamp": "2023-03-09T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 288109,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 226728,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 193395,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 191935,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 177288,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 164102,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 104848,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 97961,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 85171,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 77217,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 61409,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 48656,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 36956,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28407,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 20566,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 20360,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12861,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6646,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4298,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 452,
      "timestamp": "2023-03-09T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 289432,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 227859,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 195091,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 193164,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 177950,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 164534,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 105042,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 98365,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 85718,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 78174,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 62033,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 48987,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37037,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28462,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 21025,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 20505,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12950,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6676,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4322,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 454,
      "timestamp": "2023-03-09T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 290464,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 228546,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 196636,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 194421,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 178878,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 164885,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 105589,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 98850,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 86241,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 78540,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 62352,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 49134,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37091,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28487,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 21101,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 20586,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 12996,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6739,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4356,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 455,
      "timestamp": "2023-03-09T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 291513,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 229462,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 197152,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 195074,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 179813,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 165312,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 105953,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 99825,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 86812,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 78952,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 62526,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 49276,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37159,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28552,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 21135,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 20901,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13023,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6809,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4384,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T15:00:00-05:00",
      "votes": 455
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 293728,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 230574,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 197959,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 197281,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 180788,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 165969,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 106225,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 100228,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 87306,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 79347,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 62562,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 49419,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37254,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28585,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 21379,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 21224,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13029,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6863,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4511,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 457,
      "timestamp": "2023-03-09T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 294838,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 231935,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 198877,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 198430,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 181179,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 167841,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 106651,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 100584,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 87988,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 79983,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 62639,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 49756,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37320,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28597,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 21600,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 21435,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13049,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 6904,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4520,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 458,
      "timestamp": "2023-03-09T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 296049,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 233001,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 202094,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 199432,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 181793,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 168090,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 107240,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 101159,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 88408,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 80381,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 62855,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 50254,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37397,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28608,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 22210,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 21581,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13079,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7070,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4537,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 462,
      "timestamp": "2023-03-09T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 297525,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 234613,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 203524,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 200733,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 182484,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 168586,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 107743,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 101651,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 88889,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 80990,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 63125,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 50568,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37446,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28659,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 22423,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 21736,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13085,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7116,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4542,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 464,
      "timestamp": "2023-03-09T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 299769,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 236783,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 205162,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 202811,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 183647,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 170219,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 108244,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 102187,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 89498,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 81919,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 63419,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 50766,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37564,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 28832,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 22691,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 21925,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13101,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7125,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4555,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T20:00:00-05:00",
      "votes": 464
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 300568,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 237677,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 206880,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 204096,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 185353,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 172516,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 108847,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 102669,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 90038,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 82977,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 63694,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 51274,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37775,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29070,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 22951,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 22114,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13118,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7133,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4581,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 466,
      "timestamp": "2023-03-09T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 302209,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 238835,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 208832,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 205518,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 186823,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 173239,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 109646,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 103161,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 90427,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 83571,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64239,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 51650,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37917,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29094,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23123,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 22246,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13140,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7146,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4585,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 475,
      "timestamp": "2023-03-09T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 304334,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 240531,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 210128,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 206699,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 188087,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 174091,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 110219,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 103591,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 91095,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 84531,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64453,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 51971,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 37998,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29109,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23131,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 22526,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13168,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7153,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4719,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-09T23:00:00-05:00",
      "votes": 475
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 305872,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 241830,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 210412,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 207787,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 188401,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 174238,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 110398,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 103734,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 91247,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 84611,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64510,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52028,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38092,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29121,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23354,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 22700,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13206,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7158,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 4959,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 476,
      "timestamp": "2023-03-10T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 306956,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 242313,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 210581,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 208744,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 188739,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 174428,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 110643,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 103802,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 91336,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 84652,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64540,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52083,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38093,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29234,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23441,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 22766,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13310,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7162,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5002,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 477,
      "timestamp": "2023-03-10T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 307417,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 242844,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 210937,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 209723,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 189182,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 175006,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 111012,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 103823,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 91392,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 84684,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64545,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52154,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-10T02:00:00-05:00",
      "votes": 38093
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29269,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23496,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 22779,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13312,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7163,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5004,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T02:00:00-05:00",
      "votes": 477
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 307827,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 242851,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 211185,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 210126,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 189415,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 175394,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 111117,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 104122,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 91598,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 84797,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64590,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52194,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38095,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29270,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23567,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 22783,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13313,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7166,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T03:00:00-05:00",
      "votes": 5004
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 478,
      "timestamp": "2023-03-10T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 308858,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 242947,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 212216,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 210646,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 189561,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 175595,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 111196,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 104124,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 91907,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 85078,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64631,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52207,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38108,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29272,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23842,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 22784,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-10T04:00:00-05:00",
      "votes": 13313
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7168,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T04:00:00-05:00",
      "votes": 5004
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T04:00:00-05:00",
      "votes": 478
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 309548,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 243340,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 212677,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 210910,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 189780,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 176216,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 111219,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 104206,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 92112,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 85633,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64667,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52218,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38122,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29292,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23843,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 22791,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13315,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7169,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5005,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T05:00:00-05:00",
      "votes": 478
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 310060,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 244364,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 213296,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 211313,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 190045,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 176687,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 111458,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 104362,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 92524,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 85793,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64672,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52340,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38126,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29295,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23862,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 23035,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13327,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7176,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T06:00:00-05:00",
      "votes": 5005
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 479,
      "timestamp": "2023-03-10T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 311098,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 244781,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 214162,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 212106,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 190421,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 177539,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 111662,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 104606,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 93019,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 86034,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64679,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52391,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38148,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29329,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23898,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 23046,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13333,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7216,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T07:00:00-05:00",
      "votes": 5005
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 480,
      "timestamp": "2023-03-10T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 313428,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 245623,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 215023,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 213977,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 191348,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 177870,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 112177,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 105021,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 93578,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 86474,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64689,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52547,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38182,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29338,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 23926,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 23133,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13352,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7240,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5009,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T08:00:00-05:00",
      "votes": 480
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 315014,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 246826,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 216251,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 215491,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 192346,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 178129,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 112535,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 105697,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 94115,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 86741,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64781,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 52909,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38240,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29368,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 24081,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 23388,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13367,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7377,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5016,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 484,
      "timestamp": "2023-03-10T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 316217,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 247383,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 217630,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 216462,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 193005,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 178771,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 112878,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 106157,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 94495,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 87129,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64857,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 53136,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38261,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29428,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 24099,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 23648,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13377,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7436,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5018,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T10:00:00-05:00",
      "votes": 484
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 317405,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 248548,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 218746,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 217928,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 193411,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 179178,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 113291,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 106616,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 95031,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 87804,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 64891,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 53317,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38278,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29462,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 24256,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 23957,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13398,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7454,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5036,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T11:00:00-05:00",
      "votes": 484
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 318457,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 249976,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 220503,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 218973,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 194077,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 179435,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 113631,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 107132,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 95524,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 88318,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 65051,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 53387,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38349,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29484,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 24281,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 24151,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13414,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7498,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5040,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 486,
      "timestamp": "2023-03-10T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 319759,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 250529,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 221752,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 220116,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 195090,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 179629,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 113824,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 107717,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 96161,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 88952,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 65161,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 53584,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38401,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29524,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 24641,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 24412,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13422,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7634,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5042,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 487,
      "timestamp": "2023-03-10T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 321596,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 250775,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 222971,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 221901,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 195688,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 180039,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 114300,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 108208,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 96430,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 89329,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 65508,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 53916,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38440,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29534,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 25128,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 24472,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13459,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7669,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5052,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 489,
      "timestamp": "2023-03-10T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 322850,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 251737,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 225432,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 223651,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 196409,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 180346,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 114583,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 108812,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 96899,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 89536,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 65671,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 54251,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38542,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29544,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 25251,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 24698,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13477,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7674,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5054,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 490,
      "timestamp": "2023-03-10T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 323802,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 252979,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 226287,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 224799,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 197428,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 180590,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 115270,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 109368,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 97171,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 89789,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 65735,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 54654,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38670,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29558,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 25367,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 24886,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13491,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 7718,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5059,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 491,
      "timestamp": "2023-03-10T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 324955,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 253878,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 227132,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 225601,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 198079,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 181634,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 115614,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 109862,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 97600,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 90369,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 65912,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 54944,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38839,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29575,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 25602,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 25029,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13513,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8064,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5060,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 493,
      "timestamp": "2023-03-10T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 326757,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 254571,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 228051,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 227335,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 198646,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 182413,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 116132,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 110096,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 98291,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 90969,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66244,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 55236,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38901,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29587,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 25924,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 25179,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13591,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8128,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5086,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 494,
      "timestamp": "2023-03-10T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 328672,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 255792,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 231827,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 228438,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 199242,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 183385,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 116441,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 110253,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 98863,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 91612,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66294,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 55418,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 38986,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29620,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 26103,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 25272,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13625,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8162,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5094,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T19:00:00-05:00",
      "votes": 494
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 331095,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 257771,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 233293,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 229693,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 199743,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 184228,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 117130,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 110702,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 99557,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 92070,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66318,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 55517,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 39154,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29630,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 26347,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 25890,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13658,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8310,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5098,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 496,
      "timestamp": "2023-03-10T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 334125,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 258999,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 234960,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 232325,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 200734,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 185277,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 117567,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 110853,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 100236,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 92499,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66333,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 55924,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 39406,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29681,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 26646,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 26116,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13715,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8377,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5100,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 505,
      "timestamp": "2023-03-10T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 336359,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 261376,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 237304,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 233831,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 201907,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 186361,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 117925,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 111502,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 100767,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 93289,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66345,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 56460,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 39744,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29703,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 26872,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 26474,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13774,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8423,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5119,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-10T22:00:00-05:00",
      "votes": 505
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 337466,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 263248,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 238607,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 234369,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 202609,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 186981,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 118070,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 111757,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 101149,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 93839,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66357,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 56752,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 39848,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29718,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27145,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 26646,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13825,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8534,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5136,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 507,
      "timestamp": "2023-03-10T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 338523,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 263662,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 239229,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 234980,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 203327,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 187409,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 118556,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 111916,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 101316,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 93909,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66430,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57067,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 39875,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29750,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27271,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 26647,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13844,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8540,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5137,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T00:00:00-05:00",
      "votes": 507
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 340073,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 263968,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 239417,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 236070,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 203679,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 187873,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 119216,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 112012,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 101421,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 94162,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66505,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57104,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 39936,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29767,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27302,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 26661,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13849,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8545,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T01:00:00-05:00",
      "votes": 5137
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T01:00:00-05:00",
      "votes": 507
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 341283,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 264648,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 239827,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 237600,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 204705,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 188276,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 119658,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 112214,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 101519,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 94228,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66624,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57116,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 39989,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29770,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27304,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 27038,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13850,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8597,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T02:00:00-05:00",
      "votes": 5137
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T02:00:00-05:00",
      "votes": 507
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 341400,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 264684,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 240042,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 237847,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 205212,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 188444,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 119875,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 112302,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 101547,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 94244,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66625,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57120,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 39990,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29773,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27362,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 27066,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13854,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T03:00:00-05:00",
      "votes": 8597
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T03:00:00-05:00",
      "votes": 5137
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T03:00:00-05:00",
      "votes": 507
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 341405,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 264723,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 240151,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 238171,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 205383,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 188614,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 119935,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 112319,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 101553,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 94281,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66627,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57121,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-11T04:00:00-05:00",
      "votes": 39990
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T04:00:00-05:00",
      "votes": 29773
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27365,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T04:00:00-05:00",
      "votes": 27066
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13855,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T04:00:00-05:00",
      "votes": 8597
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T04:00:00-05:00",
      "votes": 5137
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T04:00:00-05:00",
      "votes": 507
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 341619,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 264974,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 240760,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 238274,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 205420,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 188648,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 120040,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 112326,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 101696,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 94285,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66628,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57167,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 40000,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29775,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27415,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 27071,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-11T05:00:00-05:00",
      "votes": 13855
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T05:00:00-05:00",
      "votes": 8597
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5138,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 509,
      "timestamp": "2023-03-11T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 342703,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 265712,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 241255,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 238351,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 205657,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 189116,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 120116,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 112430,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 101932,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 94364,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T06:00:00-05:00",
      "votes": 66628
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57226,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 40004,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29778,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27479,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 27077,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13897,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8605,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5139,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 510,
      "timestamp": "2023-03-11T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 344203,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 265822,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 242244,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 238787,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 205888,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 189411,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 120282,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 112564,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 102394,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 94588,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66636,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57350,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 40126,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29785,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27755,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 27203,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13919,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8635,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5140,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T07:00:00-05:00",
      "votes": 510
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 345692,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 266494,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 242659,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 239897,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 206278,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 189593,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 120481,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 112852,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 102785,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 94834,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 66957,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57671,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 40403,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29797,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 27914,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 27254,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13950,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8641,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5147,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T08:00:00-05:00",
      "votes": 510
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 346628,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 267376,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 243123,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 240475,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 206519,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 190057,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 120583,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 113336,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 103195,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 95043,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67062,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57755,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 40529,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29829,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 28160,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 27499,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13955,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8644,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5148,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T09:00:00-05:00",
      "votes": 510
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 348681,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 268542,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 243874,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 242211,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 207069,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 190409,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 121133,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 113812,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 103580,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 95912,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67130,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 57970,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 40755,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29862,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 28501,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 27732,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13963,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8654,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5152,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T10:00:00-05:00",
      "votes": 510
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 349893,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 269027,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 244325,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 243480,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 207569,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 191147,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 121853,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 114150,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 104051,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 96398,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67218,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 58210,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 40920,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29900,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 28974,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 28021,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 13988,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8665,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5153,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T11:00:00-05:00",
      "votes": 510
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 351673,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 270602,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 245129,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 244741,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 209001,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 191732,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 122188,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 114275,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 104325,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 96705,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67286,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 58554,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 41095,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29915,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 29188,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 28156,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14024,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8671,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5156,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 514,
      "timestamp": "2023-03-11T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 353190,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 271817,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 247365,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 245922,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 209856,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 192079,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 122503,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 114604,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 104522,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 97405,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67302,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 58908,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 41459,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29965,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 29410,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 28330,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14034,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8696,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5159,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 515,
      "timestamp": "2023-03-11T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 354316,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 272903,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 248820,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 246390,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 210205,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 192447,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 122931,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 114872,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 104923,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 97602,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67356,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 59165,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 41564,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29977,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 29760,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 28379,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14076,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8709,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T14:00:00-05:00",
      "votes": 5159
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-11T14:00:00-05:00",
      "votes": 515
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 355025,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 273479,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 249515,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 247157,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 211220,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 192575,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 123224,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 115287,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 105472,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 98483,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67448,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 59553,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 41914,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 29985,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29981,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 28414,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14124,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8718,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5161,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 516,
      "timestamp": "2023-03-11T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 356373,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 274972,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 251452,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 247713,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 211697,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 193269,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 123818,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 115484,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 105957,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 99044,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67612,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 60005,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 42540,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 30302,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 29989,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 28528,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14151,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8751,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5162,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 517,
      "timestamp": "2023-03-11T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 357683,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 275585,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 251890,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 248556,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 212237,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 193634,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 124217,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 116037,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 106545,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 99460,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67739,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 60373,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 42980,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 30537,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30001,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 28965,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14205,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8754,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5165,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 519,
      "timestamp": "2023-03-11T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 359637,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 277631,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 252748,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 250319,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 212684,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 194259,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 124548,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 116223,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 107126,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 99701,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67804,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 60703,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 43166,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 30773,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30023,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 29559,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14245,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8758,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5171,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 526,
      "timestamp": "2023-03-11T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 360809,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 279199,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 253973,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 250463,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 213306,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 194887,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 124977,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 116408,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 107458,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 100038,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67836,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 61290,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 43257,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 31090,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30060,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 29680,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14303,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8767,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5176,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 527,
      "timestamp": "2023-03-11T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 362219,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 281443,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 255945,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 251361,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 214809,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 195215,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 125467,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 116677,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 108096,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 101129,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 67865,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 61820,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 43535,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 31315,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30083,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 29834,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14327,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8768,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5182,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 529,
      "timestamp": "2023-03-11T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 364017,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 282650,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 257232,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 252805,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 216035,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 195942,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 125943,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 116851,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 108637,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 101925,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68057,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 62183,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 44124,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 31484,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30288,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 30226,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14343,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8778,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5226,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 531,
      "timestamp": "2023-03-11T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 366252,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 284841,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 258421,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 254254,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 217068,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 196839,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 126239,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 117229,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 109174,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 102513,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68160,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 62446,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 45007,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 31706,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 30376,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30364,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14373,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8782,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5228,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 532,
      "timestamp": "2023-03-11T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 368376,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 286594,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 259770,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 255110,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 217916,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 197311,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 126579,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 117412,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 109990,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 102847,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68227,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 62576,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 45382,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32016,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 30482,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30406,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14381,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8786,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5234,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 534,
      "timestamp": "2023-03-11T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 369930,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 287150,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 260364,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 255460,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 218625,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 197545,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 126664,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 117521,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 110328,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 103341,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68231,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 62677,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 45752,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32067,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 30763,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30424,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14390,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8788,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5236,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 536,
      "timestamp": "2023-03-12T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 370586,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 287379,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 260871,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 256029,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 218706,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 197668,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 126752,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 117572,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 110392,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 103403,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68233,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 62734,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 46017,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32074,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 30963,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30429,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14395,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8798,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5237,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T01:00:00-05:00",
      "votes": 536
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 370810,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 287683,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 261110,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 256921,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 219023,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 197787,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 126789,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 117577,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 110591,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 103474,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68236,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 62819,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 46107,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T03:00:00-04:00",
      "votes": 32074
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 30964,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30430,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14435,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8801,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5281,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 540,
      "timestamp": "2023-03-12T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 371219,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 287741,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 261299,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 257261,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 219408,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 197798,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 126910,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 117610,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 110657,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 103486,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68237,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 62852,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 46162,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32075,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T04:00:00-04:00",
      "votes": 30964
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T04:00:00-04:00",
      "votes": 30430
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14440,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8802,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5282,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T04:00:00-04:00",
      "votes": 540
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 371922,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 287753,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 261614,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 258008,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 219558,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 197833,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 126931,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 117643,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 110704,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 103517,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68238,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 62943,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 46164,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 32075
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 30964
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 30430
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 14440
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8803,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5283,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T05:00:00-04:00",
      "votes": 540
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 372139,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 288630,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 261690,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 258199,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 219668,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 198207,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 127030,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 117669,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 110729,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 103522,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T06:00:00-04:00",
      "votes": 68238
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 63044,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 46171,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32076,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 30967,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30463,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14444,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8841,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T06:00:00-04:00",
      "votes": 5283
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 541,
      "timestamp": "2023-03-12T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 372821,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 289279,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 262042,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 258392,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 219678,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 198933,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 127209,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 117758,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 111207,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 103714,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T07:00:00-04:00",
      "votes": 68238
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 63180,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 46183,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32120,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 30968,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30466,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14449,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8899,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T07:00:00-04:00",
      "votes": 5283
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 542,
      "timestamp": "2023-03-12T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 373712,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 290459,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 262415,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 258973,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 219891,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 199270,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 127464,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 118031,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 111458,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 103946,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T08:00:00-04:00",
      "votes": 68238
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 63310,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 46268,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32245,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 30994,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30490,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14458,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8926,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5287,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T08:00:00-04:00",
      "votes": 542
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 374782,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 290793,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 263345,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 259076,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 220602,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 199469,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 127735,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 118232,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 111897,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 104111,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68245,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 63454,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 46473,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32658,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 31044,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30491,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14466,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8934,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5296,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 545,
      "timestamp": "2023-03-12T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 377016,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 291572,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 264015,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 260527,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 221159,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 199562,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 128056,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 118394,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 112135,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 104382,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68410,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 63578,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 46722,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32728,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 31074,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30547,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14490,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8935,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5310,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 546,
      "timestamp": "2023-03-12T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 378322,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 293305,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 264754,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 261819,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 221414,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 199748,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 128187,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 118607,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 112525,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 104839,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68422,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 63800,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 47058,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32815,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 31118,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30556,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14517,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8938,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5316,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 547,
      "timestamp": "2023-03-12T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 380383,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 294232,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 265584,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 263820,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 222291,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 200067,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 128557,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 118726,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 113300,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 105157,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68426,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 64014,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 47521,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 32849,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 31123,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30576,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14535,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8940,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5318,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 548,
      "timestamp": "2023-03-12T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 382540,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 295282,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 266214,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 265042,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 222980,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 200606,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 128777,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 119010,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 113908,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 105533,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68443,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 64374,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 48115,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 33069,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 31279,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30616,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14552,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8970,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5321,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T13:00:00-04:00",
      "votes": 548
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 384236,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 296721,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 268100,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 266082,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 223770,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 200848,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 129099,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 119366,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 114288,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 105732,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68545,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 64675,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 48637,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 33179,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 31610,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30621,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14570,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 8998,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5325,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 550,
      "timestamp": "2023-03-12T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 385322,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 297620,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 268732,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 266481,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 224210,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 201435,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 129509,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 119702,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 114921,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 106123,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68552,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 65038,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 48745,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 33334,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 32209,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30630,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14583,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9012,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5328,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T15:00:00-04:00",
      "votes": 550
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 386493,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 298200,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 269466,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 267026,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 225165,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 201986,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 130115,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 120151,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 115827,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 106469,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68564,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 65409,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 48787,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 33759,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 32353,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30639,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14618,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9054,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5338,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 552,
      "timestamp": "2023-03-12T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 387840,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 300093,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 272241,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 268176,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 225821,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 202748,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 130329,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 120429,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 116895,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 106803,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68576,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 65815,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 48998,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 34116,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 32522,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30654,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14624,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9072,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5344,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 557,
      "timestamp": "2023-03-12T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 389492,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 301678,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 273723,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 269110,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 226343,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 203275,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 130720,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 120827,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 117803,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 107739,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 68979,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 66400,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 49296,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 34318,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 32757,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30665,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14670,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9081,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5355,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 559,
      "timestamp": "2023-03-12T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 392817,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 303899,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 274786,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 271890,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 227366,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 203910,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 130959,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 121043,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 118904,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 107989,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 69106,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 66994,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 49503,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 34663,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 32811,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30699,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14705,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9212,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5357,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 560,
      "timestamp": "2023-03-12T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 395002,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 305821,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 275829,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 273951,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 229194,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 204836,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 131543,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 121929,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 120050,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 108254,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 69221,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 67287,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 49781,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 34889,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 32982,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30711,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14715,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9221,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5359,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 562,
      "timestamp": "2023-03-12T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 397178,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 308508,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 277303,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 276205,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 231078,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 205953,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 131882,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 122402,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 121219,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 108922,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 69615,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 67536,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 50172,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 34987,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 33534,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30722,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14751,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9224,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-12T21:00:00-04:00",
      "votes": 5359
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 576,
      "timestamp": "2023-03-12T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 399155,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 310463,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 279991,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 277010,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 233124,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 206764,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 132520,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 123845,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 122087,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 110491,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 69820,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 68160,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 50277,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35087,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34239,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30762,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14770,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9232,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5361,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 578,
      "timestamp": "2023-03-12T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 401215,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 311703,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 281953,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 278099,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 234539,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 207374,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 133712,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 124611,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 122773,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 111264,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 70020,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 68521,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 50671,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35163,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34426,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30770,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14778,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9268,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5363,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 579,
      "timestamp": "2023-03-12T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 404299,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 312393,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 282832,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 280352,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 235974,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 207776,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 134038,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 124952,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 123334,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 111397,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 70323,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 68734,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 50834,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35302,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34450,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30778,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14901,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9277,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T00:00:00-04:00",
      "votes": 5363
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 580,
      "timestamp": "2023-03-13T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 406181,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 313302,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 283422,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 282046,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 236951,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 207935,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 134426,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 125094,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 123674,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 111545,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T01:00:00-04:00",
      "votes": 70323
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 68787,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51015,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35404,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34455,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30779,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 14992,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T01:00:00-04:00",
      "votes": 9277
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T01:00:00-04:00",
      "votes": 5363
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T01:00:00-04:00",
      "votes": 580
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 406527,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 313665,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 283641,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 282398,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 237328,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 208259,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 134498,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 125185,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 124052,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 111567,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 70324,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 68861,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51025,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35509,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34457,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30788,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15013,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9279,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5364,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T02:00:00-04:00",
      "votes": 580
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 407258,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 313769,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 284237,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 282860,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 237534,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 208412,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 134586,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 125344,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 124222,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 111743,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 70324
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 68943,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51090,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35650,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34495,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 30788
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15014,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9283,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 5364
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 580
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 408348,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 314058,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 284530,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 283477,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 237640,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 208445,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 134659,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 125422,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 124378,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 111752,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 70332,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 69003,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51136,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35723,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34505,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T04:00:00-04:00",
      "votes": 30788
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15016,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9294,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T04:00:00-04:00",
      "votes": 5364
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T04:00:00-04:00",
      "votes": 580
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 408933,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 315294,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 284981,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 283874,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 238144,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 208724,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 134866,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 125633,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 125026,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 111822,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 70334,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 69116,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51147,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35744,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34519,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30803,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15017,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9297,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T05:00:00-04:00",
      "votes": 5364
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T05:00:00-04:00",
      "votes": 580
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 409682,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 315385,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 285247,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 284453,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 239021,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 209099,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 135056,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 125777,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 125555,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 112012,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T06:00:00-04:00",
      "votes": 70334
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 69156,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51195,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35750,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34532,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30804,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15025,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T06:00:00-04:00",
      "votes": 9297
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5367,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T06:00:00-04:00",
      "votes": 580
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 410543,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 315830,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 285826,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 285689,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 239373,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 209303,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 135563,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 126352,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 126124,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 112156,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 70336,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 69298,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51223,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35807,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34578,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T07:00:00-04:00",
      "votes": 30804
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15034,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9307,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5368,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T07:00:00-04:00",
      "votes": 580
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 411731,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 316889,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 287453,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 287289,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 240510,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 209686,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 135785,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 127227,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 126302,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 112370,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 70421,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 69443,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51230,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 35992,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34602,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30813,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15054,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9318,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5370,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T08:00:00-04:00",
      "votes": 580
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 413327,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 318499,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 290423,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 288880,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 241219,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 210115,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 136102,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 127923,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 126660,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 112768,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 70426,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 69835,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51271,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 36338,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34636,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30821,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15104,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9319,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5376,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T09:00:00-04:00",
      "votes": 580
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 413982,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 318832,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 292183,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 289191,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 242137,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 210328,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 136384,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 128647,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 127383,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 113444,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 71024,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 70147,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51302,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 36782,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34757,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30865,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15142,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9348,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5382,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 581,
      "timestamp": "2023-03-13T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 416514,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 320843,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 294165,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 291648,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 243468,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 210575,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 136515,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 129642,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 128148,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 113781,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 71430,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 70690,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51385,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 37033,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34795,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30931,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15204,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9359,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5391,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T11:00:00-04:00",
      "votes": 581
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 417790,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 322320,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 296041,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 292855,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 245528,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 211023,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 136744,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 130449,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 128920,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 114231,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 71830,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 71009,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51525,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 37147,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 34859,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 30972,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15223,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9408,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5394,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 582,
      "timestamp": "2023-03-13T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 418920,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 322850,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 297953,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 293643,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 246307,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 211714,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 137018,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 131283,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 129443,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 114808,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 72035,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 71340,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51579,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 37291,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 35034,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31081,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15266,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9423,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5397,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 583,
      "timestamp": "2023-03-13T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 420368,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 324276,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 299774,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 294583,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 247179,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 212154,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 137412,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 132115,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 129922,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 115173,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 72687,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 71545,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51607,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 37362,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 35445,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31140,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15301,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9506,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5402,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 584,
      "timestamp": "2023-03-13T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 421558,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 325293,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 302529,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 296121,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 248272,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 212508,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 137880,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 132720,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 131193,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 115954,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 72992,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 71835,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51647,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 37521,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 35581,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31218,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15307,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9513,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5407,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 586,
      "timestamp": "2023-03-13T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 423063,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 326298,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 304043,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 297325,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 249252,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 212881,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 138411,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 133485,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 132156,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 116161,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 73638,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 72288,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 51891,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 37691,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 35650,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31252,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15384,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9538,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5412,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 589,
      "timestamp": "2023-03-13T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 424806,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 327342,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 305557,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 298740,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 249573,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 213545,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 139112,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 134597,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 133002,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 116662,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 73864,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 72672,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 52031,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 37859,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 36082,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31298,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15410,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9589,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5421,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 591,
      "timestamp": "2023-03-13T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 427179,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 328277,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 308850,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 300407,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 251038,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 214008,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 139826,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 135994,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 133676,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 116944,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 74117,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 72968,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 52116,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 38036,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 36308,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31353,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15419,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9773,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5426,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 593,
      "timestamp": "2023-03-13T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 427757,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 330436,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 310486,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 300767,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 252952,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 214361,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 140870,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 136844,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 134426,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 117270,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 74275,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 73400,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 52271,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 38214,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 36417,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31397,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15437,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9825,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5431,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 594,
      "timestamp": "2023-03-13T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 428991,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 334215,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 312219,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 301994,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 255160,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 215018,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 141946,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 137704,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 134930,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 118287,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 74664,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 74529,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 52498,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 38447,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 36991,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31460,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15477,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9832,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5442,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 596,
      "timestamp": "2023-03-13T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 430899,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 335152,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 314064,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 304137,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 257792,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 215363,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 143499,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 139161,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 135651,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 119306,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 75587,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 75070,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 52625,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 38779,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 37696,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31518,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15603,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9857,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5447,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T21:00:00-04:00",
      "votes": 596
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 432748,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 336716,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 316183,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 305298,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 259544,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 216868,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 145101,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 140406,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 136576,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 120618,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 76493,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 75499,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 52758,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 38883,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 37903,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31566,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15623,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9874,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5449,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 599,
      "timestamp": "2023-03-13T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 435936,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 338267,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 318986,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 307766,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 261097,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 217862,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 145543,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 141151,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 137333,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 121114,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 77245,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 76397,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 52812,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39164,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 38876,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31579,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15662,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9880,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5464,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 601,
      "timestamp": "2023-03-13T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 437817,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 340882,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 320013,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 309521,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 262296,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 218630,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 146062,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 141594,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 137850,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 121711,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 77575,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 76829,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 52946,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 39735,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39282,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31629,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15676,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9886,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5504,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 602,
      "timestamp": "2023-03-14T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 438114,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 341147,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 320549,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 309909,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 262901,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 219734,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 146455,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 142001,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 138010,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 121973,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 77721,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 76848,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53106,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 39782,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39329,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31683,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-14T01:00:00-04:00",
      "votes": 15676
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9903,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5506,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 603,
      "timestamp": "2023-03-14T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 438532,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 341149,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 320951,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 310770,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 263516,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 220023,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 147022,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 142161,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 138034,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 122015,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 77932,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 77153,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53107,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 39809,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39363,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31690,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15713,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9909,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T02:00:00-04:00",
      "votes": 5506
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T02:00:00-04:00",
      "votes": 603
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 439316,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 341295,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 321399,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 311812,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 263975,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 220219,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 147169,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 142650,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 138112,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 122169,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 78163,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 77154,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53110,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 39884,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39495,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31764,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15815,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9921,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T03:00:00-04:00",
      "votes": 5506
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T03:00:00-04:00",
      "votes": 603
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 440043,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 341481,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 321548,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 312312,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 264567,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 220405,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 147337,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 143082,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 138363,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 122268,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 78255,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 77155,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53131,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 40205,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39633,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31765,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15816,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9923,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T04:00:00-04:00",
      "votes": 5506
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 605,
      "timestamp": "2023-03-14T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 440416,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 342108,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 321799,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 312623,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 265231,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 220464,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 147517,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 143309,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 138464,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 122301,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 78357,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 77271,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53132,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 40209,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39738,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31766,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-14T05:00:00-04:00",
      "votes": 15816
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9924,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5507,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 606,
      "timestamp": "2023-03-14T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 441668,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 342635,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 322265,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 312912,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 265962,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 220989,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 147634,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 143614,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 138632,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 122470,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 78419,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 77427,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53205,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 40345,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39787,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31796,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15858,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9946,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5508,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T06:00:00-04:00",
      "votes": 606
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 441937,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 343187,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 322868,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 313209,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 266957,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 221270,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 147908,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 143932,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 138752,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 122637,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 78579,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 77678,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53251,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 40420,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39820,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31799,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15881,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9948,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T07:00:00-04:00",
      "votes": 5508
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 607,
      "timestamp": "2023-03-14T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 443149,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 344050,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 323810,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 314830,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 267637,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 221471,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 148383,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 144418,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 139101,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 122771,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 78816,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 77755,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53328,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 40772,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 39964,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31845,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15892,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 9993,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5512,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 620,
      "timestamp": "2023-03-14T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 445983,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 345339,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 325027,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 316683,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 268672,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 221988,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 148802,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 145200,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 139646,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 122845,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 79645,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 77810,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53405,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 41000,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 40149,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31866,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15914,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10056,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5516,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 623,
      "timestamp": "2023-03-14T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 447126,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 347011,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 325883,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 317465,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 269767,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 222235,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 149378,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 145920,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 140101,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 123806,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 80321,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 77942,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53470,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 41313,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 40338,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31879,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15919,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10089,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5527,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T10:00:00-04:00",
      "votes": 623
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 447785,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 348743,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 327035,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 318742,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 270961,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 222819,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 149870,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 147034,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 140493,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 124685,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 80820,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 78512,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53500,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 41479,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 40566,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31889,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 15962,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10098,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5538,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 626,
      "timestamp": "2023-03-14T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 448909,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 349453,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 328264,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 319858,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 272714,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 223173,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 150291,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 147796,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 141251,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 125206,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 81256,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 79437,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53562,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 41784,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 40756,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 31894,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16035,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10127,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5540,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 628,
      "timestamp": "2023-03-14T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 449860,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 351035,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 331750,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 320618,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 273564,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 223568,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 150686,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 148600,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 142038,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 125791,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 81549,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 79586,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53624,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 41878,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 40782,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32044,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16112,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10211,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T13:00:00-04:00",
      "votes": 5540
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T13:00:00-04:00",
      "votes": 628
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 451413,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 352580,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 332559,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 321798,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 274473,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 224112,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 151105,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 149450,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 142501,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 126145,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 81821,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 79659,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53654,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 42224,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 40887,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32157,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16134,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10265,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5554,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 631,
      "timestamp": "2023-03-14T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 452295,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 354279,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 333601,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 322434,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 276061,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 224383,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 151453,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 150167,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 143203,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 126372,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 82367,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 80405,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53716,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 42337,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41056,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32272,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16209,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10336,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5556,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 632,
      "timestamp": "2023-03-14T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 454152,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 355603,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 334326,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 323010,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 276692,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 224927,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 152170,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 150807,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 143699,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 127392,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 82752,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 80615,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53745,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 42533,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41164,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32310,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16225,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10367,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5558,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T16:00:00-04:00",
      "votes": 632
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 455890,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 357184,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 335006,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 324397,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 279299,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 225447,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 152631,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 151208,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 144172,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 127593,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 83009,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 80889,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53756,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 42638,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41177,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32337,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16237,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10393,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5563,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T17:00:00-04:00",
      "votes": 632
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 456739,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 358273,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 335416,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 325077,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 280812,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 225699,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 153595,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 151691,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 144651,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 127804,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 83345,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 81357,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53767,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 42776,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41181,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32403,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16247,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10408,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5568,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 633,
      "timestamp": "2023-03-14T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 458127,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 359400,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 336212,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 325953,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 282291,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 226037,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 154405,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 152175,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 144898,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 128307,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 83926,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 81752,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53837,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 42898,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41258,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32421,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16259,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10427,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5570,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 634,
      "timestamp": "2023-03-14T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 460617,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 361410,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 337157,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 327246,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 283644,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 227116,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 154835,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 152790,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 145169,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 129551,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 84518,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 81777,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 53970,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 43143,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41358,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32445,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16284,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10459,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5573,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 637,
      "timestamp": "2023-03-14T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 462507,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 365344,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 338025,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 328310,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 284947,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 228954,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 155440,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 153332,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 145477,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 130513,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 85242,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 81845,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54028,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 43405,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41410,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32498,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16313,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10507,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5574,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T21:00:00-04:00",
      "votes": 637
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 463661,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 366768,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 338881,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 329257,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 286587,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 230198,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 155966,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 153751,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 145821,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131282,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 85845,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82004,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54148,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44045,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41499,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32533,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16324,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10536,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5611,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 639,
      "timestamp": "2023-03-14T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 464441,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 367626,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 339555,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 329805,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 287191,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 230494,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 156261,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 154091,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146039,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131375,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 86128,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82065,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54180,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44148,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41548,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32546,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16346,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10543,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5612,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T23:00:00-04:00",
      "votes": 639
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 465101,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 368670,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 340026,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330759,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288016,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 230956,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 156605,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 154347,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146306,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131470,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 86281,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82083,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54273,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44176,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41565,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32556,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16357,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10549,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T00:00:00-04:00",
      "votes": 5612
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T00:00:00-04:00",
      "votes": 639
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 465192,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 368694,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 340145,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330821,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288177,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231057,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 156710,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 154550,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146374,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131572,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 86389,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82102,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54274,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44231,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41578,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32562,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-15T01:00:00-04:00",
      "votes": 16357
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10555,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T01:00:00-04:00",
      "votes": 5612
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 640,
      "timestamp": "2023-03-15T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 465233,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 368714,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 340214,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330837,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288373,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231058,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 156735,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 154694,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146380,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131640,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 86414,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82118,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-15T02:00:00-04:00",
      "votes": 54274
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44248,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41582,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32569,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16370,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10556,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T02:00:00-04:00",
      "votes": 5612
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T02:00:00-04:00",
      "votes": 640
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 465254,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 368720,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 340282,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330868,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288428,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231060,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 156791,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 154906,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146422,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131650,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 86439,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 82118
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 54274
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44255,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 41582
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 32569
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16450,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 10556
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 5612
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 640
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 465324,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 368760,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 340382,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330888,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288441,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231074,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 156827,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 155056,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146480,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131702,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 86519,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82119,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54275,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44256,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41598,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32571,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16451,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T04:00:00-04:00",
      "votes": 10556
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T04:00:00-04:00",
      "votes": 5612
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T04:00:00-04:00",
      "votes": 640
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 465345,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 368772,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 340522,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330894,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288447,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231090,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 156839,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 155158,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146499,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131722,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 86648,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82124,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-15T05:00:00-04:00",
      "votes": 54275
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44291,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41625,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32573,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16455,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T05:00:00-04:00",
      "votes": 10556
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T05:00:00-04:00",
      "votes": 5612
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T05:00:00-04:00",
      "votes": 640
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 465550,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 368785,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 340749,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330910,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288537,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231103,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 156906,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 155390,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146533,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131784,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 86749,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T06:00:00-04:00",
      "votes": 82124
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-15T06:00:00-04:00",
      "votes": 54275
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44314,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41659,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32585,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16458,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10559,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5614,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 641,
      "timestamp": "2023-03-15T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 465694,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 368843,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 341014,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330933,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288572,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231142,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 157097,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 155800,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146677,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131864,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 86923,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82131,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54276,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44320,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41732,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32612,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16466,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10562,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5615,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T07:00:00-04:00",
      "votes": 641
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 465848,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 368916,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 341311,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330958,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288696,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231173,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 157200,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 156247,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146829,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 131999,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 87198,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82147,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54282,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44375,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41818,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32639,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16471,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10564,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5616,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 642,
      "timestamp": "2023-03-15T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 466087,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 369136,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 341949,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 330988,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 288920,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231200,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 157746,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 157385,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 146958,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 132185,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 87416,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82193,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54303,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44412,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41855,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32648,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16482,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10629,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5621,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 644,
      "timestamp": "2023-03-15T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 466178,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 369235,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 342415,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331036,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 289028,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231303,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 158420,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 157657,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 147183,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 132240,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 87710,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82297,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54355,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44450,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41877,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32659,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16517,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10675,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5681,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 646,
      "timestamp": "2023-03-15T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 466375,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 369278,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 342878,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331082,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 289131,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231338,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 159053,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 157853,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 147462,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 132371,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 87999,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82306,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54370,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44534,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 41901,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32679,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16531,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10706,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5785,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T11:00:00-04:00",
      "votes": 646
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 466449,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 369361,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 343330,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331150,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 289420,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231395,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 159586,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 158184,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 147767,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 132528,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 88317,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82319,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54385,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44594,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42000,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32753,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16551,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10741,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5798,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 648,
      "timestamp": "2023-03-15T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 466596,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 369440,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 343715,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331186,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 289573,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231474,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 160126,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 158537,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 147932,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 132631,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 88564,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82337,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54388,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44636,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42076,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32765,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16590,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10768,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5805,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T13:00:00-04:00",
      "votes": 648
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 466709,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 369619,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 344117,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331230,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 289613,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231564,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 160534,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 158841,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 148062,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 132765,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 88851,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82368,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54403,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44733,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42216,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32782,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16618,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10795,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5808,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 652,
      "timestamp": "2023-03-15T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 466791,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 369699,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 344455,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331262,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 289707,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231598,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 160938,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 159237,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 148200,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 132884,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 89254,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82413,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54416,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44766,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42257,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32810,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16767,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10810,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5809,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T15:00:00-04:00",
      "votes": 652
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 466911,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 369731,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 345014,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331404,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 289911,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231637,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 161422,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 159457,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 148469,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 132950,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 89579,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82455,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54437,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44829,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42397,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32815,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16806,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10819,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5828,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 654,
      "timestamp": "2023-03-15T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 467133,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 369883,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 345423,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331470,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 290045,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231723,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 161869,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 159662,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 148626,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 133048,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 89695,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82486,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54461,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 44923,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42547,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32819,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16815,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10849,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5830,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 656,
      "timestamp": "2023-03-15T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 467323,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 370020,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 345733,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331569,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 290191,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231801,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 162293,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 159882,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 148850,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 133225,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 89864,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82538,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54490,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45017,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42592,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32837,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16824,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10859,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5832,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 657,
      "timestamp": "2023-03-15T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 467471,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 370078,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 346319,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331609,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 290437,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231888,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 162694,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 160195,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 149266,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 133378,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 90315,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82624,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54507,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45087,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42659,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32847,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16862,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10888,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5836,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T19:00:00-04:00",
      "votes": 657
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 467679,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 370231,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 346767,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331648,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 290689,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 231950,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 163279,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 160616,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 149435,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 133570,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 90813,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82655,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54534,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45207,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42709,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32871,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16909,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10891,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5838,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T20:00:00-04:00",
      "votes": 657
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 467891,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 370435,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 348367,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331697,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 290991,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 232133,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 163739,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 160869,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 149655,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 133868,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 91310,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82685,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54574,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45302,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42841,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32902,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16935,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10935,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5841,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T21:00:00-04:00",
      "votes": 657
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 468052,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 370577,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 349490,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331748,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 291362,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 232437,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 164245,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 161207,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 149954,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 134008,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 91707,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82727,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54578,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45400,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 42979,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32912,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16941,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10939,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5926,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T22:00:00-04:00",
      "votes": 657
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 468271,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 370662,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 349836,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 331825,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 291466,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 232706,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 164496,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 161394,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 150372,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 134099,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92055,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82742,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54586,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45458,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43050,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32938,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16970,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10943,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5942,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 658,
      "timestamp": "2023-03-15T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 468755,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 371770,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 350130,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 332438,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 291839,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 232916,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 164728,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 161732,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 150671,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 134169,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92143,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82790,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54627,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45500,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43083,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32945,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 16972,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10966,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T00:00:00-04:00",
      "votes": 5942
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 670,
      "timestamp": "2023-03-16T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 469476,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 372451,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 350551,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 333788,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 292535,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 233367,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 164839,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 162220,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 150746,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 134526,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92194,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82812,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54635,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45629,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43113,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 32946,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17028,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10968,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5944,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T01:00:00-04:00",
      "votes": 670
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 469906,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 372520,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 350810,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 334693,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 292847,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 233866,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 164885,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 162600,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 150793,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 134598,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92230,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82833,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54648,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45933,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T02:00:00-04:00",
      "votes": 43113
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33003,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17031,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 10984,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T02:00:00-04:00",
      "votes": 5944
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T02:00:00-04:00",
      "votes": 670
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 470004,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 372908,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 350931,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 334700,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 293171,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 234055,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 165006,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 162977,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 150952,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 134866,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92241,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T03:00:00-04:00",
      "votes": 82833
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-16T03:00:00-04:00",
      "votes": 54648
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T03:00:00-04:00",
      "votes": 45933
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43120,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T03:00:00-04:00",
      "votes": 33003
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17035,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11002,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T03:00:00-04:00",
      "votes": 5944
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T03:00:00-04:00",
      "votes": 670
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 470355,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 373328,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 351433,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 334860,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 293991,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 234177,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 165073,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 163450,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 150971,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 135187,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92329,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82846,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-16T04:00:00-04:00",
      "votes": 54648
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45945,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T04:00:00-04:00",
      "votes": 43120
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33006,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-16T04:00:00-04:00",
      "votes": 17035
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11003,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5951,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T04:00:00-04:00",
      "votes": 670
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 470758,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 374382,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 351581,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 334994,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 294389,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 234400,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 165227,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 163584,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 150987,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 135207,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92441,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82875,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54652,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45949,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43122,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T05:00:00-04:00",
      "votes": 33006
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17036,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11005,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T05:00:00-04:00",
      "votes": 5951
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T05:00:00-04:00",
      "votes": 670
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 471307,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 375505,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 351817,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 335112,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 295475,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 234702,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 165352,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 164016,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 151036,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 135226,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92473,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82876,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54654,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45957,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43207,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33007,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17049,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11007,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5953,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T06:00:00-04:00",
      "votes": 670
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 471740,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 375668,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 352076,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 335364,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 295626,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 235589,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 165620,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 164310,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 151105,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 135288,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92604,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82884,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54699,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45965,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43238,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33019,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17054,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11036,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T07:00:00-04:00",
      "votes": 5953
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T07:00:00-04:00",
      "votes": 670
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 472498,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 376845,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 353120,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 336208,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 296063,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 235961,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 166082,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 164535,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 151488,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 135361,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 92751,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 82907,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54710,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 45970,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43261,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33027,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17062,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11046,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5960,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 672,
      "timestamp": "2023-03-16T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 474100,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 377904,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 353545,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 338048,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 296681,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 236744,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 166411,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 164996,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 151593,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 135797,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 93191,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 83058,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54747,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46027,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43285,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33057,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17091,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11047,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5964,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T09:00:00-04:00",
      "votes": 672
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 475533,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 379322,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 353925,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 339695,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 297569,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 237748,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 167063,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 165317,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 151674,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 136060,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 93526,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 83074,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54768,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46067,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43346,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33062,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17124,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11053,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5967,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 674,
      "timestamp": "2023-03-16T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 477262,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 380857,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 354289,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 341734,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 298786,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 238762,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 167440,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 165928,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 151923,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 136174,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 93789,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 83474,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54786,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46119,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43398,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33066,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17182,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11060,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5974,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 680,
      "timestamp": "2023-03-16T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 478337,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 382252,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 354642,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 342971,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 299906,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 239050,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 168116,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 166768,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 152064,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 136413,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 94044,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 84079,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54813,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46148,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43462,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33101,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17219,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11073,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5975,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 681,
      "timestamp": "2023-03-16T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 478944,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 383453,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 355473,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 343455,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 301262,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 239697,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 168573,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 167279,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 152265,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 137298,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 94254,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 84119,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54848,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46386,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43534,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33107,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17301,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11085,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 5979,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T13:00:00-04:00",
      "votes": 681
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 479625,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 383875,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 356171,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 344181,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 302093,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 240027,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 168822,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 167856,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 152425,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 137520,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 94588,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 84197,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54880,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46420,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43609,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33113,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17315,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11117,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6002,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T14:00:00-04:00",
      "votes": 681
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 480493,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 385203,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 356694,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 345951,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 302973,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 240348,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 169330,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 168247,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 152567,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 137866,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 94929,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 85008,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54941,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46438,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43654,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33119,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17327,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11127,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6004,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 682,
      "timestamp": "2023-03-16T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 482470,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 387000,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 357071,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 347980,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 303977,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 241016,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 169957,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 168721,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 152643,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 138361,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 95250,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 86055,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54953,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46520,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43667,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33123,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17335,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11136,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6008,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 683,
      "timestamp": "2023-03-16T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 483830,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 388364,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 357428,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 349174,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 304580,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 241903,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 170454,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 169086,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 152824,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 138712,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 95472,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 86158,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54983,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46816,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43730,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33130,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17354,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11148,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6010,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 684,
      "timestamp": "2023-03-16T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 485300,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 388850,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 357950,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 350581,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 305481,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 242799,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 170913,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 169390,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 153078,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 139376,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 95655,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 86374,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 54992,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46847,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43784,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33154,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17368,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11188,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6013,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T18:00:00-04:00",
      "votes": 684
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 486479,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 390523,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 359176,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 351770,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 307267,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 243496,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 171349,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 169990,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 153398,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 139909,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 95974,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 86535,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55032,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46888,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43846,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33155,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17410,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11216,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6015,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T19:00:00-04:00",
      "votes": 684
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 488754,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 392440,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 360460,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 353028,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 308214,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 244381,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 172036,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 170740,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 153651,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 140676,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 96392,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 86586,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55064,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 46992,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 43925,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33161,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17416,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11252,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T20:00:00-04:00",
      "votes": 6015
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 700,
      "timestamp": "2023-03-16T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 490013,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 394160,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 361470,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 354172,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 309610,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 245182,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 172745,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 171367,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 154073,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 141249,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 96992,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 86600,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55115,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47063,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44152,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33170,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17448,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11285,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6017,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 704,
      "timestamp": "2023-03-16T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 492747,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 395434,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 362534,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 356553,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 311337,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 245994,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 173224,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 172268,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 154699,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 141530,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 97390,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 86603,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55132,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47517,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44263,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33174,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17469,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11344,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6041,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 708,
      "timestamp": "2023-03-16T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 494886,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 398183,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 364764,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 358073,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 313663,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 246110,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 173733,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 172782,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155003,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 141628,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 97575,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 87667,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55174,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47518,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44340,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33179,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17485,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11348,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6046,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T23:00:00-04:00",
      "votes": 708
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 497060,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 398978,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 365242,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 359768,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 314947,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 246888,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 174234,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 173069,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155247,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 141747,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 97649,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88266,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55222,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47821,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44400,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33183,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17488,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11359,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6047,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T00:00:00-04:00",
      "votes": 708
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 498071,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 400305,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 365789,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 360663,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 315685,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 246994,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 174557,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 173677,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155291,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 142088,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 97722,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88511,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55280,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47824,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44401,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33207,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17538,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11361,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6048,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T01:00:00-04:00",
      "votes": 708
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 499858,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 400678,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 365846,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 362310,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 315773,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 247052,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 174721,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 173964,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155293,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 142169,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 97754,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88518,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55294,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47900,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44403,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33210,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17609,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11411,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T02:00:00-04:00",
      "votes": 6048
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T02:00:00-04:00",
      "votes": 708
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 501455,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 400867,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 366023,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 363326,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 315911,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 247571,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 174796,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 174264,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155354,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 142296,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 97804,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88521,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55296,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47913,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44413,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T03:00:00-04:00",
      "votes": 33210
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17610,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T03:00:00-04:00",
      "votes": 11411
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6049,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T03:00:00-04:00",
      "votes": 708
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 502146,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 401049,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 366266,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 364197,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 316608,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 247601,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 174935,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 174614,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155412,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 142305,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 97892,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88536,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 55296
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 47913
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44418,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33212,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 17610
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 11411
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 6049
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 708
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 503106,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 402036,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 366539,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 365197,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 317356,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 247742,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 175335,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 174807,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155417,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 142334,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 97971,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 88536
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 55296
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47915,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44419,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 33212
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17614,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11413,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 6049
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T05:00:00-04:00",
      "votes": 708
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 504421,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 402702,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 367050,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 366513,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 318082,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 248387,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 175646,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 175166,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155470,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 142506,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 98044,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88541,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55305,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47976,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44473,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33218,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17619,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11414,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6050,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 709,
      "timestamp": "2023-03-17T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 505336,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 402846,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 367679,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 367544,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 318418,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 249282,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 176078,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 175734,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155525,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 142759,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 98113,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88556,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55322,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 47983,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44490,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33221,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17623,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11427,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6051,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 710,
      "timestamp": "2023-03-17T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 506700,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 403739,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 369230,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 369209,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 319254,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 249826,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 176980,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 176323,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155543,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 142909,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 98310,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88566,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55400,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48058,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44517,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33224,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17629,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11460,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6054,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 712,
      "timestamp": "2023-03-17T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 508014,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 405211,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 371758,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 369947,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 320271,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 250501,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 177675,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 176930,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155716,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 143399,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 98475,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 88645,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55408,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48069,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44522,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33234,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17636,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11487,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6055,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T09:00:00-04:00",
      "votes": 712
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 508916,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 406918,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 373125,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 370951,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 320998,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 250816,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 178221,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 178102,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 155870,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 143560,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 98787,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 89036,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55425,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48113,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44537,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33238,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17641,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11488,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T10:00:00-04:00",
      "votes": 6055
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T10:00:00-04:00",
      "votes": 712
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 510217,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 408345,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 374022,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 371774,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 322509,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 251013,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 179768,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 179135,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 156001,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 143662,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 99019,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 89305,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55461,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48149,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44563,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33244,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17663,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11546,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6059,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 716,
      "timestamp": "2023-03-17T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 511477,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 409393,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 375326,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 372856,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 323687,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 251083,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 180569,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 180240,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 156590,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 143941,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 99320,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 89348,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55477,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48165,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44645,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33251,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17707,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11589,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6063,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 722,
      "timestamp": "2023-03-17T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 512376,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 411850,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 376087,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 373511,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 324235,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 251216,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 181913,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 180905,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 156683,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 144282,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 99635,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 89756,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55497,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48204,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44677,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33258,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17718,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11599,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6066,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 724,
      "timestamp": "2023-03-17T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 513938,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 412077,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 376613,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 374281,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 325113,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 251523,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 182742,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 181432,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 156965,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 144523,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 99811,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 90047,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55514,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48233,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44724,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33288,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17730,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11641,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6069,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 725,
      "timestamp": "2023-03-17T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 515792,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 413065,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 377234,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 376276,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 326480,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 252032,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 183673,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 182319,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 157178,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 144781,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 100069,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 90332,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55551,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48308,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44775,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33301,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17746,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11666,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6072,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 727,
      "timestamp": "2023-03-17T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 517783,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 414067,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 378322,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 377983,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 327174,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 252644,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 184487,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 182767,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 157305,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 145490,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 100315,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 90430,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55571,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48413,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44779,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33312,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17753,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11687,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6093,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 728,
      "timestamp": "2023-03-17T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 518707,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 415046,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 379727,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 378677,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 328719,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 253079,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 184951,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 183322,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 157547,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 145995,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 100618,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 90461,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55588,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48519,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44803,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33323,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17784,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11697,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6094,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 730,
      "timestamp": "2023-03-17T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 519611,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 415985,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 380884,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 379299,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 329836,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 253509,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 185352,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 183843,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 158237,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 146306,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 100873,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 90514,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55602,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48852,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44872,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33328,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17810,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11709,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6113,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 732,
      "timestamp": "2023-03-17T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 520216,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 416812,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 381914,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 379656,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 330811,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 253996,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 185911,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 184613,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 158650,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 146955,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 101100,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 90531,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55643,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48894,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44918,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33331,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17815,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11718,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6115,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T19:00:00-04:00",
      "votes": 732
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 522130,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 419856,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 382682,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 380849,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 332972,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 254865,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 187286,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 185326,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 159152,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 147816,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 101385,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 90759,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55676,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 48974,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 44968,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33335,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17823,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11736,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6117,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 737,
      "timestamp": "2023-03-17T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 524108,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 421073,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 383909,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 382319,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 334077,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 255504,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 188191,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 185959,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 159545,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 148032,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 101663,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91255,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55691,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 49326,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45078,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33337,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17827,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11758,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6118,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 739,
      "timestamp": "2023-03-17T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 526407,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 422544,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 385106,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 384798,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 335010,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 256604,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 188719,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 186364,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 160029,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 148555,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 101981,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91394,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55726,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 49475,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45147,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33344,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17845,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11775,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6121,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 742,
      "timestamp": "2023-03-17T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 527937,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 425755,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 387510,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 385972,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 336486,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 257017,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 189263,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 186860,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 160222,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 149043,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 102390,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91598,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55752,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 49862,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45173,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33345,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17852,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11782,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6123,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 743,
      "timestamp": "2023-03-17T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 529738,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 426609,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 388581,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 387729,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 337228,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 257895,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 189461,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 187302,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 160559,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 149308,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 102685,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91602,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55791,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 49920,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45175,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33385,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-18T00:00:00-04:00",
      "votes": 17852
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11790,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6124,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 745,
      "timestamp": "2023-03-18T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 531065,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 426849,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 389893,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 389117,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 338152,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 258301,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 190052,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 187614,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 160765,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 149369,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 102832,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91610,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-18T01:00:00-04:00",
      "votes": 55791
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 49947,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45209,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33400,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17916,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11798,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6125,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T01:00:00-04:00",
      "votes": 745
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 532495,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 427251,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 391589,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 389778,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 338657,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 258417,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 190263,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 187894,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 161005,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 149413,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 102915,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91662,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55795,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50156,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45236,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33402,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 17995,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T02:00:00-04:00",
      "votes": 11798
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6130,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T02:00:00-04:00",
      "votes": 745
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 533450,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 427496,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 392075,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 390020,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 338971,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 258572,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 190391,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 188302,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 161007,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 149416,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 102945,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91692,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55805,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50185,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45278,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T03:00:00-04:00",
      "votes": 33402
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18013,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11802,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T03:00:00-04:00",
      "votes": 6130
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T03:00:00-04:00",
      "votes": 745
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 534088,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 427723,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 392397,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 390302,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 339381,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 258722,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 190499,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 188379,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 161022,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 149428,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 103033,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91712,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55806,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50341,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 45278
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33406,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 18013
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11804,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 6130
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 745
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 534374,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 427925,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 392523,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 390646,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 339745,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 258960,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 190566,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 188513,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 161023,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 149531,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 103121,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91718,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55815,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50343,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T05:00:00-04:00",
      "votes": 45278
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33407,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18014,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T05:00:00-04:00",
      "votes": 11804
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T05:00:00-04:00",
      "votes": 6130
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T05:00:00-04:00",
      "votes": 745
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 535060,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 428487,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 392930,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 391463,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 339922,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 259359,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 191089,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 188681,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 161082,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 149666,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 103215,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91726,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55817,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50424,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45301,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33408,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-18T06:00:00-04:00",
      "votes": 18014
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11806,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T06:00:00-04:00",
      "votes": 6130
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T06:00:00-04:00",
      "votes": 745
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 535663,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 429222,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 394096,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 392018,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 340340,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 260050,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 192119,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 188955,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 161176,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 150127,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 103282,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91760,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55828,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50501,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T07:00:00-04:00",
      "votes": 45301
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33413,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-18T07:00:00-04:00",
      "votes": 18014
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T07:00:00-04:00",
      "votes": 11806
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T07:00:00-04:00",
      "votes": 6130
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 746,
      "timestamp": "2023-03-18T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 536967,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 429948,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 395231,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 393050,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 341479,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 260269,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 192469,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 189496,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 161464,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 150465,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 103348,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91783,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55961,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50507,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45313,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33417,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18021,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11817,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T08:00:00-04:00",
      "votes": 6130
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T08:00:00-04:00",
      "votes": 746
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 539765,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 430644,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 396804,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 393944,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 342286,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 260422,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 192777,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 189802,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 161958,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 150545,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 103466,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 91866,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 55975,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50535,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45353,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33419,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18026,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11828,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6131,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 749,
      "timestamp": "2023-03-18T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 541240,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 432288,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 398160,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 394636,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 343064,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 261117,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 193324,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 190182,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 162105,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 150893,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 103748,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 92173,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56071,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50575,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45405,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33423,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18030,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11859,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6133,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T10:00:00-04:00",
      "votes": 749
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 542397,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 433660,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 399637,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 395477,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 344264,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 261777,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 193974,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 190467,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 162246,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 151047,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 104008,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 92515,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56220,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50738,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45464,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33433,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18037,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11867,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6134,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 752,
      "timestamp": "2023-03-18T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 543687,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 434644,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 400418,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 396491,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 345783,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 262038,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 194382,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 190771,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 162844,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 151320,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 104133,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 92787,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56256,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50804,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45510,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33449,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18063,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11893,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6135,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T12:00:00-04:00",
      "votes": 752
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 546141,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 435850,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 402040,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 397713,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 346676,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 262480,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 195022,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 191034,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 163351,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 151589,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 104486,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 92953,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56385,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 50917,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45524,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33466,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18082,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11896,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T13:00:00-04:00",
      "votes": 6135
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 753,
      "timestamp": "2023-03-18T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 547844,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 436360,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 403261,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 399166,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 347366,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 262814,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 195832,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 191442,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 163740,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 152034,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 104732,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 93157,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56527,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 51116,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45549,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33473,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18086,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11900,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6148,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 754,
      "timestamp": "2023-03-18T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 549329,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 437866,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 404705,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 402470,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 348883,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 263560,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 196638,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 191749,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 164439,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 152625,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 104929,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 93301,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56650,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 51162,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45615,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33482,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18093,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11924,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6149,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T15:00:00-04:00",
      "votes": 754
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 551162,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 439280,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 406614,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 404801,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 350093,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 263992,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 197316,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 192174,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 164510,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 153290,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 105191,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 94095,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56759,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 51176,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45635,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33527,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18099,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11936,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6150,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T16:00:00-04:00",
      "votes": 754
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 552637,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 440870,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 408270,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 405516,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 351241,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 264467,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 197825,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 192539,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 164673,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 153494,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 105436,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 95023,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56823,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 51250,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45706,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33568,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18102,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11938,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6152,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 756,
      "timestamp": "2023-03-18T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 554194,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 442053,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 409414,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 406533,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 352127,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 264755,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 198183,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 192901,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 164873,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 153883,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 105630,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 95711,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56904,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 51336,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45751,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33575,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18104,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11946,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6154,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T18:00:00-04:00",
      "votes": 756
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 556251,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 443611,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 411245,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 407041,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 352979,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 265132,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 198792,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 193489,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 165134,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 154165,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 105904,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 96611,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 56970,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 51476,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45798,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33580,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-18T19:00:00-04:00",
      "votes": 18104
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11952,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6157,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 757,
      "timestamp": "2023-03-18T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 559852,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 444631,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 413705,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 407893,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 354828,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 265700,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 199656,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 194169,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 165372,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 154695,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 106207,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 96988,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 57042,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 51509,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45854,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33588,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18128,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11956,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6162,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 762,
      "timestamp": "2023-03-18T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 561536,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 446252,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 414689,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 409285,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 356173,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 266215,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 201163,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 194830,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 165625,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 155310,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 106551,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 97736,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 57157,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 51585,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 45927,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33590,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18135,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11964,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6163,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T21:00:00-04:00",
      "votes": 762
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 563116,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 447539,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 416109,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 411292,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 357567,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 266695,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 202332,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 195152,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 165966,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 155531,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 106835,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 98911,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 57435,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 51788,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46008,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33594,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18140,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11990,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6166,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 763,
      "timestamp": "2023-03-18T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 563955,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 448970,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 417374,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 411923,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 359296,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 266995,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 203049,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 195418,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166146,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 156099,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 107026,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 100273,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 57664,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52027,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46080,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33601,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18154,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11991,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T23:00:00-04:00",
      "votes": 6166
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T23:00:00-04:00",
      "votes": 763
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 566623,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 450650,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 420685,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 412710,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 360635,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 267655,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 203499,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 195511,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166271,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 156352,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 107069,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 100986,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 57759,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52085,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46148,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33603,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18163,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11995,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T00:00:00-04:00",
      "votes": 6166
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 764,
      "timestamp": "2023-03-19T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 567560,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 451568,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 421595,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 412945,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 361514,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 267791,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 203691,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 195610,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166357,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 156601,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 107145,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 101801,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 57968,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52191,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46196,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33604,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18239,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11996,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T01:00:00-04:00",
      "votes": 6166
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T01:00:00-04:00",
      "votes": 764
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 567963,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 452214,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 421870,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 413103,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 361823,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 268513,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 204175,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 195712,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166455,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 156738,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 107200,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 102032,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 58069,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52276,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46221,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33606,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18300,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 11998,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T02:00:00-04:00",
      "votes": 6166
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T02:00:00-04:00",
      "votes": 764
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 568163,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 452414,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 422245,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 413334,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 362533,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 268581,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 204496,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 196032,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166480,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 156800,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 107233,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 102170,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 58251,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52420,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 46221
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33616,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18302,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 11998
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 6166
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 765,
      "timestamp": "2023-03-19T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 568363,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 452647,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 422474,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 413879,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 362583,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 268599,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 204650,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 196140,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166488,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 156822,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 107316,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 102187,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 58251
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52509,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46234,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33617,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18303,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 11998
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 6166
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T04:00:00-04:00",
      "votes": 765
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 568915,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 452814,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 422802,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 413967,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 362638,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 269022,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 204725,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 196222,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166510,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 156853,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 107391,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 102199,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 58257,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 52509
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46235,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 33617
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18304,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 11998
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6167,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T05:00:00-04:00",
      "votes": 765
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 569533,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 453337,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 423078,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 414068,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 363058,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 269097,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 204786,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 196339,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166517,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 156923,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 107650,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 102203,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 58260,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52513,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46244,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 33617
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 18304
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 11998
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6168,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 765
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 570234,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 453838,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 423139,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 414445,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 363903,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 269817,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 204855,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 196651,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166531,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 157038,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 107820,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 102221,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 58271,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52540,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46261,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33624,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18309,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12004,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6169,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T07:00:00-04:00",
      "votes": 765
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 572208,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 454353,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 425172,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 414847,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 364894,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 270335,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 205285,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 196969,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166557,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 157355,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 108034,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 102710,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 58440,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52570,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46317,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33629,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18312,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12008,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6170,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T08:00:00-04:00",
      "votes": 765
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 573650,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 455071,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 426344,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 415540,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 365543,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 270376,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 206359,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 197204,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166796,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 157493,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 108120,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 103695,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 58603,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52600,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46333,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33637,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18317,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12016,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6175,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T09:00:00-04:00",
      "votes": 765
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 574881,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 456259,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 427410,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 416497,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 366124,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 270475,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 206994,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 197360,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 166975,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 157576,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 108428,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 104180,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 58761,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52872,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46339,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33645,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18347,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12017,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6177,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T10:00:00-04:00",
      "votes": 765
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 575987,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 457300,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 428625,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 421483,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 367049,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 270729,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 207835,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 197663,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 167087,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 157751,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 108548,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 105462,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 58938,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52875,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46362,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33689,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18364,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12020,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6179,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 767,
      "timestamp": "2023-03-19T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 577351,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 457927,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 429395,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 423444,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 368364,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 271231,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 208495,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 198162,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 167158,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 158071,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 108706,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 105677,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 59030,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52894,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46388,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33692,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18384,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12025,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6180,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T12:00:00-04:00",
      "votes": 767
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 578723,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 459272,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 430482,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 424534,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 369299,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 271844,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 209163,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 198674,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 167620,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 158484,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 108792,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 106422,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 59279,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 52975,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46437,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33698,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18400,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12028,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6183,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 768,
      "timestamp": "2023-03-19T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 579849,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 460120,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 431623,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 425845,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 370156,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 271997,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 209705,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 199018,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 167678,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 159061,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 108925,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 107201,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 59558,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53018,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46500,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33702,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18405,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12048,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6187,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T14:00:00-04:00",
      "votes": 768
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 583156,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 461265,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 433892,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 429225,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 371303,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 272519,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 210532,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 199357,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 167887,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 159911,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 109460,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 109182,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 59651,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53138,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46534,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33706,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18426,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12081,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6200,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T15:00:00-04:00",
      "votes": 768
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 584832,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 462279,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 434905,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 430095,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 372288,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 272628,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 211073,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 199733,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 168332,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 160146,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 110586,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 109586,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 59787,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53169,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46565,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33712,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18436,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12096,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6203,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T16:00:00-04:00",
      "votes": 768
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 585977,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 462996,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 435834,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 431410,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 373196,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 273058,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 212065,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 200162,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 168575,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 160348,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 111663,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 110194,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 59962,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53175,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46595,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33715,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18446,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12098,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6205,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T17:00:00-04:00",
      "votes": 768
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 587985,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 463886,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 437107,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 432409,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 374342,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 273707,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 212485,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 200702,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 168921,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 160996,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 113107,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 110526,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 60423,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53239,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46656,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33727,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18452,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12100,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T18:00:00-04:00",
      "votes": 6205
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T18:00:00-04:00",
      "votes": 768
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 590571,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 466746,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 438947,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 435770,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 375108,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 274767,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 213119,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 201228,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 169764,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 161220,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 113358,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 110768,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 60904,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53270,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46677,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33738,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18469,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12102,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6206,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T19:00:00-04:00",
      "votes": 768
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 593493,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 468052,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 441452,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 438826,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 376701,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 276356,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 214342,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 201861,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 170646,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 161874,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 113420,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 111042,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 61608,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53394,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46784,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33751,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18476,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12108,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6210,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T20:00:00-04:00",
      "votes": 768
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 596008,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 469923,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 444020,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 440530,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 378803,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 277796,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 215665,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 202123,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 171080,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 162723,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 114777,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 111361,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 61940,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53485,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46836,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33797,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18494,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12124,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6213,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T21:00:00-04:00",
      "votes": 768
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 597908,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 471112,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 445342,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 442692,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 380061,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 279141,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 216923,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 202507,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 171586,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 162976,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 115945,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 111660,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 62357,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53681,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46858,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33938,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18498,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12126,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6214,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T22:00:00-04:00",
      "votes": 768
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 599952,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 473684,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 447689,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 444603,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 382125,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 279953,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 217984,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 202681,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 171900,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 163124,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 116695,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 111881,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 63222,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53866,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46881,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33948,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18503,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12131,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6215,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 770,
      "timestamp": "2023-03-19T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 602203,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 475236,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 450516,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 445034,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 383805,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 280694,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 218591,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 202850,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172135,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 163482,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 117070,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 111994,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 64026,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53980,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T00:00:00-04:00",
      "votes": 46881
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 33952,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18561,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12133,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6216,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T00:00:00-04:00",
      "votes": 770
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 602954,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 476461,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 451774,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 445196,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 384358,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 280911,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 219336,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 203004,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172180,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 163526,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 117524,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 112049,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 64869,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53981,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46882,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34001,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18624,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12134,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T01:00:00-04:00",
      "votes": 6216
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T01:00:00-04:00",
      "votes": 770
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 603180,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 477118,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 452182,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 445439,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 384700,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 281174,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 219827,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 203048,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172235,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 163571,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 117784,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 112171,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 64870,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 53991,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 46882
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 34001
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18626,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 12134
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 6216
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 770
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 603641,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 477596,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 453123,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 445830,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 385125,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 281352,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 220034,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 203077,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172248,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 163655,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 118045,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 112233,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 64883,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54019,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 46882
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34006,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18650,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 12134
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 6216
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 770
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 604168,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 477919,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 453664,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 445925,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 385520,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 281353,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 220326,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 203198,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172271,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 163672,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 118502,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 112260,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 64930,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54028,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46912,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34018,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 18650
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 12134
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 6216
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 770
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 604911,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 478055,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 454056,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 446524,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 385716,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 281546,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 220420,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 203388,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172306,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 163974,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 118662,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 112279,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 64965,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 54028
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46940,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34024,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 18650
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 12134
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T05:00:00-04:00",
      "votes": 6216
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 771,
      "timestamp": "2023-03-20T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 606045,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 478427,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 454671,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 447037,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 386278,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 282195,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 220613,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 203544,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172353,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 164039,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 118681,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 112294,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 65074,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54088,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T06:00:00-04:00",
      "votes": 46940
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T06:00:00-04:00",
      "votes": 34024
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18656,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12135,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6217,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T06:00:00-04:00",
      "votes": 771
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 606939,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 479223,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 455005,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 447848,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 386593,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 282304,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 220960,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 203710,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172404,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 164106,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 118771,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 112361,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 65708,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T07:00:00-04:00",
      "votes": 54088
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 46989,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34033,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18661,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12136,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T07:00:00-04:00",
      "votes": 6217
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T07:00:00-04:00",
      "votes": 771
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 608088,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 480516,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 457089,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 448817,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 387409,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 282644,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 221685,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 204080,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172449,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 164186,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 119031,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 112480,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 66030,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54097,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47005,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34038,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18664,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12139,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6219,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 773,
      "timestamp": "2023-03-20T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 609930,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 481689,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 458687,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 449419,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 388098,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 282869,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 221959,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 204469,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172549,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 164386,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 119492,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 112696,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 66491,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54308,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47022,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34048,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18670,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12143,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6221,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 774,
      "timestamp": "2023-03-20T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 611061,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 482768,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 459720,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 449916,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 389094,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 283262,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 222273,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 204888,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 172775,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 164594,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 120341,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 113134,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 66856,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54403,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47028,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34062,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18676,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12146,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6227,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 776,
      "timestamp": "2023-03-20T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 612125,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 484415,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 461462,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 450573,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 390075,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 283447,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 222718,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 205423,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 173199,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 164899,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 121499,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 113451,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 67075,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54489,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47045,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34067,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18679,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12150,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6228,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 778,
      "timestamp": "2023-03-20T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 612960,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 485187,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 462382,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 451531,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 391189,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 283954,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 223257,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 205852,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 173600,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 165026,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 122095,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 113820,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 67134,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54496,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47050,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34068,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18686,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12269,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6246,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 780,
      "timestamp": "2023-03-20T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 613505,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 486596,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 462693,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 452423,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 393012,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 284152,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 223824,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 206358,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 174137,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 165464,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 122709,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 114122,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 67581,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54548,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47081,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34095,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18693,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12332,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6247,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 793,
      "timestamp": "2023-03-20T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 614928,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 488314,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 464420,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 455223,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 394653,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 284241,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 224608,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 206650,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 174341,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 165661,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 123511,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 114396,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 67837,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54592,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47157,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34125,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18708,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12375,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6250,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 794,
      "timestamp": "2023-03-20T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 616461,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 488800,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 465185,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 455948,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 395878,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 284668,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 225346,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 206836,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 174586,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 166521,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 124835,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 114464,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 68206,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54608,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T15:00:00-04:00",
      "votes": 47157
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34129,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18724,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12403,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T15:00:00-04:00",
      "votes": 6250
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 796,
      "timestamp": "2023-03-20T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 617362,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 490856,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 465730,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 456387,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 396394,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 285276,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 225738,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 207067,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 174822,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 167123,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 125686,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 114653,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 68364,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54644,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47190,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34134,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18752,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12440,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T16:00:00-04:00",
      "votes": 6250
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T16:00:00-04:00",
      "votes": 796
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 618722,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 492408,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 466941,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 456890,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 397780,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 286542,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 226223,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 207408,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 175088,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 167597,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 127011,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 114736,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 68816,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54748,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47204,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34173,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18805,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12470,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6253,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T17:00:00-04:00",
      "votes": 796
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 620765,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 493556,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 468784,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 459152,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 400288,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 286984,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 226566,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 207769,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 175281,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 168406,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 127863,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 114958,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 69566,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54768,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47253,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34243,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18842,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12479,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T18:00:00-04:00",
      "votes": 6253
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 799,
      "timestamp": "2023-03-20T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 622956,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 494153,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 469892,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 460392,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 401154,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 288151,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 227158,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 208043,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 175593,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 168834,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 128644,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 115118,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 69864,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 54950,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47307,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34253,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18851,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12492,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6255,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 800,
      "timestamp": "2023-03-20T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 625048,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 496010,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 471034,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 461665,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 402742,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 288897,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 228569,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 208496,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 175991,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 169523,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 130021,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 115290,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 70138,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55283,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47361,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34262,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18859,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12504,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T20:00:00-04:00",
      "votes": 6255
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T20:00:00-04:00",
      "votes": 800
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 627306,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 497745,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 472148,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 462618,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 404356,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 293363,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 229149,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 208787,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 176399,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 170436,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 130491,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 115468,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 70785,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55361,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47395,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34310,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18879,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12540,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6256,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 801,
      "timestamp": "2023-03-20T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 628597,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 499117,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 472501,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 463605,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 406264,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 295503,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 230100,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209085,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 177118,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 171074,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 130986,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 115594,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 71190,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55432,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47450,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34317,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18892,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12576,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6259,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T22:00:00-04:00",
      "votes": 801
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 631615,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 502072,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 474688,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 464408,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 407607,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 296902,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 230819,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209271,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 177247,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 171325,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 131814,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 115815,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 71612,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55553,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47469,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34328,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 18965,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12662,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6260,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 802,
      "timestamp": "2023-03-20T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 633172,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 503699,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 475868,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 464759,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 408173,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 297925,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 231204,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209326,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 177393,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 172063,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 132770,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 115860,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 72011,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55577,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47488,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34336,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19005,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12712,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T00:00:00-04:00",
      "votes": 6260
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 803,
      "timestamp": "2023-03-21T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 634022,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 504152,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 476696,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 465133,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 408423,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 298028,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 231374,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209376,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 177446,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 172078,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 132888,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 115881,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 72681,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T01:00:00-04:00",
      "votes": 55577
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T01:00:00-04:00",
      "votes": 47488
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34340,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19008,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12715,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T01:00:00-04:00",
      "votes": 6260
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T01:00:00-04:00",
      "votes": 803
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 634252,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 504259,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 476803,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 465304,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 408704,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 298080,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 231512,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209383,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 177464,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 172107,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 133504,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 115887,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 73112,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55579,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47490,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34346,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19032,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12721,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T02:00:00-04:00",
      "votes": 6260
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 804,
      "timestamp": "2023-03-21T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 635065,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 504956,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 477342,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 465404,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 409073,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 298779,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 231893,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209496,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 177482,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 172131,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 133835,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 115970,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 73319,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55625,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 47490
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34351,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 19032
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12723,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 6260
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T03:00:00-04:00",
      "votes": 804
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 635156,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 505616,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 477528,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 465614,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 409665,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 299150,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 232135,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209518,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 177798,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 172136,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 133837,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 116041,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 73336,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55627,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 47490
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 34351
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 19032
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12727,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 6260
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 804
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 635926,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 505837,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 478510,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 465973,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 409942,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 299179,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 232314,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209624,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 178047,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 172283,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 134212,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 116071,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 73337,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T05:00:00-04:00",
      "votes": 55627
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T05:00:00-04:00",
      "votes": 47490
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34352,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19034,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12729,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T05:00:00-04:00",
      "votes": 6260
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T05:00:00-04:00",
      "votes": 804
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 637474,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 506898,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 478931,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 466520,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 411211,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 299366,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 232520,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209773,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 178120,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 172526,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 134596,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 116083,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 73361,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55646,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47492,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T06:00:00-04:00",
      "votes": 34352
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19044,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12732,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6261,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T06:00:00-04:00",
      "votes": 804
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 638119,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 507459,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 479367,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 467237,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 411833,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 300482,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 233042,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 209916,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 178210,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 173014,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 134676,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 116114,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 73509,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T07:00:00-04:00",
      "votes": 55646
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47514,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34355,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19047,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12743,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T07:00:00-04:00",
      "votes": 6261
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 808,
      "timestamp": "2023-03-21T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 640424,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 509826,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 481788,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 468108,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 412736,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 300853,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 233498,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 210269,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 178592,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 173499,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 134744,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 116205,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 73668,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55660,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47522,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34361,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19100,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12762,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6263,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 809,
      "timestamp": "2023-03-21T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 641558,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 510992,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 483140,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 470546,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 413347,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 301319,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 233802,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 210658,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 179058,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 173654,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 135325,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 116329,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 73995,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55673,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47551,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34362,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19114,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12818,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6264,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 810,
      "timestamp": "2023-03-21T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 643416,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 511875,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 484409,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 472511,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 414231,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 301491,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 234183,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 210888,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 179428,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 174421,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 135866,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 116861,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 74285,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55723,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47568,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34366,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19117,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12834,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6266,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T10:00:00-04:00",
      "votes": 810
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 644171,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 512778,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 485338,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 475081,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 414887,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 302110,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 234676,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 211291,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 179858,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 175041,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 137158,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 116958,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 74333,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55736,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47577,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34387,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19122,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12865,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6267,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T11:00:00-04:00",
      "votes": 810
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 644413,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 514185,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 485690,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 479443,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 416156,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 302624,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 235097,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 211586,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 180457,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 175389,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 137886,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 117228,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 74500,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55744,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47583,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34394,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19123,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12920,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6268,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T12:00:00-04:00",
      "votes": 810
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 646223,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 515346,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 487223,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 484506,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 416910,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 303000,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 235417,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 211803,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 181265,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 175621,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 138237,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 117344,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 74657,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55755,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47586,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34404,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19125,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12945,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6270,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 811,
      "timestamp": "2023-03-21T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 647270,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 515935,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 488883,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 487821,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 418237,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 303549,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 236065,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 212169,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 181792,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 175947,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 138709,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 117482,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 75082,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 55845,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47615,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34451,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19128,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12957,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6274,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 812,
      "timestamp": "2023-03-21T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 648604,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 517748,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 492505,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 489621,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 419395,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 303895,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 236346,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 212363,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 182090,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 176302,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 139250,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 117647,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 75448,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 56072,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47652,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34458,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19139,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 12997,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6275,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 815,
      "timestamp": "2023-03-21T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 649503,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 519216,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 493973,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 490419,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 420217,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 304876,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 237078,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 212562,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 182648,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 176981,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 139993,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 117750,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 76076,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 56092,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47698,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34460,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19152,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13010,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6305,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T16:00:00-04:00",
      "votes": 815
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 650126,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 520156,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 495853,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 490764,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 421911,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 305623,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 238582,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 213243,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 183128,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 177516,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 140170,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 117897,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 76214,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 56111,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47709,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34462,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19174,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13031,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T17:00:00-04:00",
      "votes": 6305
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 816,
      "timestamp": "2023-03-21T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 652074,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 521616,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 498133,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 491971,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 423188,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 306186,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 240240,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 213709,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 183657,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 178142,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 141206,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118033,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 76496,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 56151,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47726,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34463,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19175,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13052,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6309,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 817,
      "timestamp": "2023-03-21T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 652827,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 522891,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 500168,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 492763,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 424305,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 306975,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 240815,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 214330,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 183810,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 178593,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 142033,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118196,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 77492,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 56168,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47730,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34474,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19197,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13070,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6313,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T19:00:00-04:00",
      "votes": 817
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 654816,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 525174,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 503558,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 493368,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 425338,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 308343,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 241217,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 215295,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 184485,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 180009,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 142828,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118292,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 78218,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 56513,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47741,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34487,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19203,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13093,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6316,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 819,
      "timestamp": "2023-03-21T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 656596,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 526671,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 506183,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 496156,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 427142,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 309354,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 241739,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 215997,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 184916,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 181079,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 144049,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118466,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 78868,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 56867,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47807,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34493,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19214,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13103,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6317,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 820,
      "timestamp": "2023-03-21T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 658345,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 529408,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 507923,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 497330,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 428435,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 310622,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 242447,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 216482,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 185364,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 181626,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 145243,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118567,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 79922,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57046,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47834,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34519,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19250,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13134,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6318,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 822,
      "timestamp": "2023-03-21T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 661298,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 531694,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 509842,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 500164,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 429550,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 311628,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 243014,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 216768,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 185882,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 181936,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 148063,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118636,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 80214,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57153,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47837,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34535,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19260,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13165,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6320,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T23:00:00-04:00",
      "votes": 822
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 662725,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 533180,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 510545,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 501597,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 430852,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 312289,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 243834,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 216928,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 186004,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 182619,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 148905,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118698,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 80913,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57195,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T00:00:00-04:00",
      "votes": 47837
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34539,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19263,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13168,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6321,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T00:00:00-04:00",
      "votes": 822
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 663402,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 533720,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 511046,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 502024,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 431474,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 312620,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 244301,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 217015,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 186039,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 183233,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 149424,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118720,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 81325,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57308,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47866,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34545,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19293,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13171,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T01:00:00-04:00",
      "votes": 6321
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T01:00:00-04:00",
      "votes": 822
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 664163,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 534059,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 511260,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 502427,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 431964,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 313024,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 244596,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 217074,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 186058,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 183317,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 150010,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118726,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 81528,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57362,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47874,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T02:00:00-04:00",
      "votes": 34545
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19300,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13176,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6322,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T02:00:00-04:00",
      "votes": 822
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 664772,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 534645,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 511328,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 503289,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 432094,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 313382,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 244736,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 217139,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 186107,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 183379,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 150111,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118752,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 81639,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57375,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 47874
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34549,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19301,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13179,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6324,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 822
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 665312,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 534662,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 511477,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 504084,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 432211,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 313734,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 245006,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 217287,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 186133,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 183468,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 150200,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118784,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 81695,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 57375
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47876,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 34549
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19303,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13180,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 6324
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 822
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 665468,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 534875,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 511676,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 504422,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 432449,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 314027,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 245087,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 217452,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 186156,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 183865,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 150248,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118811,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 81743,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T05:00:00-04:00",
      "votes": 57375
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47879,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34552,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19314,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13184,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6325,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T05:00:00-04:00",
      "votes": 822
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 666669,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 535537,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 512112,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 504878,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 432624,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 314880,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 245483,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 217651,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 186311,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 184302,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 150352,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118841,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 81745,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57435,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T06:00:00-04:00",
      "votes": 47879
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34553,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19318,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13192,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T06:00:00-04:00",
      "votes": 6325
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T06:00:00-04:00",
      "votes": 822
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 667845,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 536245,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 512709,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 506343,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 433867,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 315166,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 245739,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 217781,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 186556,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 184578,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 150576,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118871,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 82224,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57481,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47888,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34579,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19320,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13204,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T07:00:00-04:00",
      "votes": 6325
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 825,
      "timestamp": "2023-03-22T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 669335,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 536869,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 514062,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 507238,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 434612,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 315298,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 245956,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 218148,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 187322,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 185155,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 150890,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 118939,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 82465,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57508,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47942,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34583,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19323,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13210,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T08:00:00-04:00",
      "votes": 6325
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T08:00:00-04:00",
      "votes": 825
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 670910,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 537769,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 515381,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 508287,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 435123,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 315752,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 246312,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 218511,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 187955,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 185625,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 151334,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 119163,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 82469,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57568,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47960,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34586,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19330,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13221,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6329,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T09:00:00-04:00",
      "votes": 825
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 671240,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 539446,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 517754,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 508630,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 435703,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 316660,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 246970,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 218902,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 188428,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 186309,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 153064,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 119280,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 82653,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57649,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 47967,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34597,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19375,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13233,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6330,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T10:00:00-04:00",
      "votes": 825
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 672047,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 540597,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 519260,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 509019,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 436648,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 317253,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 247281,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 219317,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 189437,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 186814,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 154281,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 119402,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 83312,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57783,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48001,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34621,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19390,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13237,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6331,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 827,
      "timestamp": "2023-03-22T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 673443,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 540737,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 520696,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 509856,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 437302,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 317598,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 247796,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 219676,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 189938,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 187265,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 155322,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 119644,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 83602,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57818,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48016,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34642,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19395,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13248,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6332,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 830,
      "timestamp": "2023-03-22T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 674852,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 541312,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 522065,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 511655,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 438334,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 317991,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 248100,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 220038,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 190470,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 188136,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 155709,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 119934,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 83876,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57898,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48026,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34655,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19405,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13253,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6333,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T13:00:00-04:00",
      "votes": 830
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 675781,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 542280,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 524507,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 512086,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 439261,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 318122,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 248462,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 220444,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 191316,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 188405,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 156552,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 120165,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 83971,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57943,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48033,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34659,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19427,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13257,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6334,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T14:00:00-04:00",
      "votes": 830
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 676918,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 542786,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 526548,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 512440,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 440053,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 318458,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 248852,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 220751,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 191574,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 189135,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 157187,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 120373,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 84082,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57961,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48060,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34664,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19433,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13278,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6336,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 831,
      "timestamp": "2023-03-22T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 679617,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 544380,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 527168,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 515363,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 440897,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 318954,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 249502,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 220915,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 192386,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 190048,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 157859,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 120621,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 84188,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57982,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48063,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34670,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19469,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13284,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T16:00:00-04:00",
      "votes": 6336
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T16:00:00-04:00",
      "votes": 831
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 680717,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 546216,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 528281,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 516188,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 442819,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 319318,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 249721,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 221297,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 193084,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 190588,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 158047,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 120734,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 84304,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 57994,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48109,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34694,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19503,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13364,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6338,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T17:00:00-04:00",
      "votes": 831
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 682194,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 547500,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 530773,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 517595,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 444491,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 320061,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 250150,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 221812,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 193707,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 191480,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 159222,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 120921,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 84483,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58072,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48154,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34699,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19514,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13430,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6339,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T18:00:00-04:00",
      "votes": 831
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 683429,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 549926,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 532972,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 519353,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 446316,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 321053,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 250585,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 222096,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 194199,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 192513,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 160659,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121012,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 84998,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58126,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48180,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34720,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19578,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13586,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T19:00:00-04:00",
      "votes": 6339
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 832,
      "timestamp": "2023-03-22T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 684689,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 551874,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 534813,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 519612,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 448600,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 322189,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 250816,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 222819,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 194956,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 193300,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 161242,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121197,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 85440,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58165,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48185,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34732,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19582,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13646,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6340,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 833,
      "timestamp": "2023-03-22T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 687413,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 554684,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 535894,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 520320,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 451295,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 323552,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 251201,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 223281,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 196307,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 194336,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 161772,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121314,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 86342,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58251,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48186,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34740,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19589,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13679,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6342,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 834,
      "timestamp": "2023-03-22T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 689747,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 557029,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 537872,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 522415,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 453747,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 324921,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 251560,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 223713,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 197524,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 195732,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 162215,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121466,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 86837,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58574,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48260,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34758,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19610,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13754,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T22:00:00-04:00",
      "votes": 6342
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T22:00:00-04:00",
      "votes": 834
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 692440,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 559207,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 540361,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 524548,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 454598,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 325277,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 252236,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 224072,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 198539,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 197253,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 162613,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121558,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 87445,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58678,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48293,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34763,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19672,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13831,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6345,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 835,
      "timestamp": "2023-03-22T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 694150,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 561149,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 544197,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 525678,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 456249,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 326254,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 253041,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 224230,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 198910,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 198002,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 164077,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121600,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 87569,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58847,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48306,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34781,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19702,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13887,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6346,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T00:00:00-04:00",
      "votes": 835
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 694529,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 562782,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 548589,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 526151,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 457105,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 326804,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 253498,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 224331,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 199080,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 198249,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 165713,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T01:00:00-04:00",
      "votes": 121600
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 87596,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58871,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48307,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34784,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19805,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13890,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T01:00:00-04:00",
      "votes": 6346
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 836,
      "timestamp": "2023-03-23T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 695358,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 563030,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 549539,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 527129,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 457227,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 327287,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 253631,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 224393,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 199177,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 198437,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 166543,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121612,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 87602,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 58871
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48318,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34785,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19857,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13891,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 6346
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 836
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 696835,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 563571,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 550869,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 528165,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 457396,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 327372,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 253669,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 224423,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 199268,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 199122,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 166646,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121635,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 87835,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 58871
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48319,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 34785
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19911,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13893,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 6346
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 836
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 696969,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 564199,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 551066,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 528453,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 457683,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 327570,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 253838,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 224536,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 199771,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 199357,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 166684,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121658,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-23T04:00:00-04:00",
      "votes": 87835
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58872,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T04:00:00-04:00",
      "votes": 48319
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T04:00:00-04:00",
      "votes": 34785
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 19982,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13899,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6347,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T04:00:00-04:00",
      "votes": 836
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 697199,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 565162,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 551308,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 528464,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 458278,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 327615,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 254006,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 224671,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 199871,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 199448,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 166729,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121694,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 87993,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58892,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T05:00:00-04:00",
      "votes": 48319
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34786,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20004,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13901,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T05:00:00-04:00",
      "votes": 6347
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T05:00:00-04:00",
      "votes": 836
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 698707,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 565669,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 552148,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 528939,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 459406,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 327811,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 254352,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 225067,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 200161,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 200141,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 166781,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121741,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 88366,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58893,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48347,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34787,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20010,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13908,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T06:00:00-04:00",
      "votes": 6347
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T06:00:00-04:00",
      "votes": 836
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 700138,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 566608,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 552582,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 530304,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 460501,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 328397,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 254913,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 225351,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 201023,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 200975,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 166803,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121763,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 88664,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T07:00:00-04:00",
      "votes": 58893
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48356,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34788,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20012,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13917,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T07:00:00-04:00",
      "votes": 6347
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T07:00:00-04:00",
      "votes": 836
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 700786,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 567485,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 553261,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 531313,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 462809,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 329212,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 255348,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 225639,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 202143,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 201986,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167126,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121775,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 88771,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58900,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48376,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34791,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20013,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13928,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6349,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T08:00:00-04:00",
      "votes": 836
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 701954,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 568787,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 553846,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 532350,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 463819,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 329966,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 255794,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 226180,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 203302,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 202853,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167317,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121878,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 88804,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58925,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48382,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34804,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20020,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 13976,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6352,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 839,
      "timestamp": "2023-03-23T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 703528,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 570099,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 555127,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 533312,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 464808,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330250,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 256134,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 226511,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 204502,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 204425,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167411,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121940,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89261,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58955,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48384,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34808,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20022,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14003,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6353,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T10:00:00-04:00",
      "votes": 839
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 704559,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 570990,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 556920,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534056,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 465686,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330341,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 256526,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 226758,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 205578,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 205432,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167668,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 121968,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89338,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 58972,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48398,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34815,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20033,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14021,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6354,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T11:00:00-04:00",
      "votes": 839
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 704658,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 571101,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 557308,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534099,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 465812,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330376,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 256629,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 227036,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 206268,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 205775,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167691,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122029,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89355,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59035,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48448,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34824,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20037,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14026,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6357,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T12:00:00-04:00",
      "votes": 839
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 704738,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 571132,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 557678,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534163,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 465935,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330401,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 256791,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 227312,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 206932,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 206260,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167738,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122157,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89359,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59165,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48451,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34829,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20043,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14037,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6358,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 840,
      "timestamp": "2023-03-23T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 704925,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 571174,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 557979,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534191,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 466080,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330455,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 257157,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 227772,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 207383,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 206681,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167800,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122247,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89374,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59198,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48453,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34832,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20056,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14042,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6361,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 845,
      "timestamp": "2023-03-23T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 705095,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 571268,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 558470,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534227,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 466264,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330530,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 257310,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 228034,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 207775,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 207075,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167833,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122309,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89377,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59234,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48454,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34857,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20063,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14052,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T15:00:00-04:00",
      "votes": 6361
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T15:00:00-04:00",
      "votes": 845
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 705182,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 571420,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 558861,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534290,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 466353,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330579,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 257411,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 228298,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 208364,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 207275,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167845,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122430,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89408,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59288,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48455,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34861,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20089,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14064,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T16:00:00-04:00",
      "votes": 6361
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T16:00:00-04:00",
      "votes": 845
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 705309,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 571485,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 559312,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534385,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 466425,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330676,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 257550,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 228588,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 208909,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 207489,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167862,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122521,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89421,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59346,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48460,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34862,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20097,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T17:00:00-04:00",
      "votes": 14064
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6362,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T17:00:00-04:00",
      "votes": 845
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 705434,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 571642,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 560068,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534423,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 466499,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330793,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 257712,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 228913,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 209518,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 207651,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167893,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122588,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89428,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59397,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48495,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34867,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20102,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14096,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6363,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 846,
      "timestamp": "2023-03-23T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 705528,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 571739,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 560738,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534456,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 466745,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330834,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 257882,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 229410,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 210079,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 207863,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167911,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122692,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89439,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59448,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48517,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34877,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20110,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14114,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6366,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 847,
      "timestamp": "2023-03-23T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 705644,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 572021,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 561468,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534514,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 466818,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 330946,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 258028,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 230240,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 210510,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 208141,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167943,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122750,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89496,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59564,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48574,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34883,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20125,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14118,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6369,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T20:00:00-04:00",
      "votes": 847
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 705779,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 572264,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 562423,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534576,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 466982,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 331095,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 258265,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 230728,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 211216,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 208492,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 167951,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122857,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89508,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59611,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48617,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34909,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20129,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14131,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6375,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 855,
      "timestamp": "2023-03-23T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 705869,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 572528,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 563257,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534686,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 467151,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 331267,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 258443,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 231209,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 211823,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 208730,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168019,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 122986,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89524,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59638,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48661,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T22:00:00-04:00",
      "votes": 34909
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20165,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14142,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6377,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 856,
      "timestamp": "2023-03-23T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 705995,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 572635,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 564083,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534740,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 467408,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 331388,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 258544,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 231440,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 212302,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 208968,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168075,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123087,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89537,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59663,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48706,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34915,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20177,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14146,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T23:00:00-04:00",
      "votes": 6377
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T23:00:00-04:00",
      "votes": 856
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 706094,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 572751,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 564815,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534797,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 467544,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 331527,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 258572,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 231762,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 212446,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 209071,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168112,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123107,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89568,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59677,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48707,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T00:00:00-04:00",
      "votes": 34915
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20182,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14147,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T00:00:00-04:00",
      "votes": 6377
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T00:00:00-04:00",
      "votes": 856
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 706161,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 572954,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 565041,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534872,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 467678,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 331577,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 258661,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 232008,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 212533,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 209157,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168137,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T01:00:00-04:00",
      "votes": 123107
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89570,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59687,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T01:00:00-04:00",
      "votes": 48707
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T01:00:00-04:00",
      "votes": 34915
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20189,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14148,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6378,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T01:00:00-04:00",
      "votes": 856
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 706173,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 572975,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 565200,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534927,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 467749,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 331616,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 258726,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 232015,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 212564,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 209179,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168147,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123114,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89575,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59699,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48709,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T02:00:00-04:00",
      "votes": 34915
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20200,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14150,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6379,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T02:00:00-04:00",
      "votes": 856
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 706268,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 573000,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 565302,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534982,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 467989,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 331896,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 258907,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 232097,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 212646,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 209184,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168158,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123150,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89583,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 59699
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 48709
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34921,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 20200
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14153,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 6379
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 857,
      "timestamp": "2023-03-24T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 706938,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 573547,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 565473,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 534996,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 468021,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 331932,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 258947,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 232114,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 212694,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 209335,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168190,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123182,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89588,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 59699
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 48709
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 34921
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 20200
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 14153
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 6379
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T04:00:00-04:00",
      "votes": 857
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 707595,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 573988,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 565691,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 535262,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 468279,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 332354,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 259026,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 232237,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 212750,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 209480,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168212,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 123182
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89599,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 59699
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48712,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 34921
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 20200
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14156,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6380,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T05:00:00-04:00",
      "votes": 857
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 709645,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 575398,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 566022,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 536143,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 469332,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 332548,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 259534,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 232296,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 213054,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 209599,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168225,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123203,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89636,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59748,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48764,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34924,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20201,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14164,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T06:00:00-04:00",
      "votes": 6380
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T06:00:00-04:00",
      "votes": 857
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 710168,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 576366,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 566830,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 537783,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 470579,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 332880,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 260086,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 232588,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 213659,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 209975,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168232,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123216,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89766,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59752,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T07:00:00-04:00",
      "votes": 48764
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T07:00:00-04:00",
      "votes": 34924
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20205,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14172,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T07:00:00-04:00",
      "votes": 6380
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 862,
      "timestamp": "2023-03-24T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 711760,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 577804,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 567304,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 539128,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 471129,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 333354,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 260643,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 232862,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 214268,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 210512,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168634,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123274,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89779,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59796,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48837,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34926,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-24T08:00:00-04:00",
      "votes": 20205
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T08:00:00-04:00",
      "votes": 14172
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6381,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 863,
      "timestamp": "2023-03-24T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 712688,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 579343,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 567900,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 539531,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 472099,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 333383,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 261092,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 233228,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 214788,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 210996,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168653,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123445,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89811,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59799,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48840,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T09:00:00-04:00",
      "votes": 34926
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20210,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14177,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6383,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 864,
      "timestamp": "2023-03-24T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 714024,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 580967,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 568719,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 539791,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 473500,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 333999,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 262094,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 233628,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 215269,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 211418,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168732,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123489,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89840,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59820,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48875,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34928,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20226,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14184,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T10:00:00-04:00",
      "votes": 6383
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T10:00:00-04:00",
      "votes": 864
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 715684,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 582749,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 569806,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 540423,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 474179,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 334205,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 262331,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 234077,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 215908,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 211750,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 168887,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123658,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 89968,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59826,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48901,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34930,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20301,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14196,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6384,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T11:00:00-04:00",
      "votes": 864
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 716857,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 584276,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 571526,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 541166,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 475212,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 334366,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 262516,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 234389,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 216226,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 212147,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169009,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123710,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 90107,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59880,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48903,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34933,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20307,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14205,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6385,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 866,
      "timestamp": "2023-03-24T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 718342,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 586793,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 572645,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 541911,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 475602,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 334456,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 262922,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 234634,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 216874,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 212876,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169028,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123772,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 90409,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59911,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48943,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34936,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20310,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14216,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6386,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T13:00:00-04:00",
      "votes": 866
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 720426,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 588438,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 573592,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 542370,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 476555,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 334544,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 263471,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 235032,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 217254,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 213629,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169068,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123828,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 90682,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59917,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48959,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34943,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20312,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14227,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6390,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 869,
      "timestamp": "2023-03-24T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 721856,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 589547,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 574410,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 543095,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 477546,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 334767,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 263843,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 235279,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 217924,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 214293,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169119,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123910,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 90847,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 59956,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 48993,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 34991,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20316,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14233,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6397,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 871,
      "timestamp": "2023-03-24T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 722860,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 591148,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 575572,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 543338,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 478570,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 334959,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 264134,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 235387,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 219027,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 215199,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169295,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 123992,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 90960,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 60035,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49013,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35003,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20337,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14239,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6439,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 872,
      "timestamp": "2023-03-24T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 723872,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 593306,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 577693,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 543672,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 479997,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 335390,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 264933,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 235620,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 219686,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 215634,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169357,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124025,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 91324,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 60100,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49022,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35032,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20348,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14243,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6441,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 873,
      "timestamp": "2023-03-24T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 726032,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 594773,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 578900,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 544340,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 482063,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 335727,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 265492,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 235934,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 220200,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 215997,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169432,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124063,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 91515,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 60234,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49024,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35071,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20361,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14271,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6443,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 874,
      "timestamp": "2023-03-24T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 728013,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 597443,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 579818,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 544665,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 484052,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 335884,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 266052,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 236322,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 220708,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 216609,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169577,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124080,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 91613,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 60373,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49045,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35082,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20377,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14302,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6445,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T19:00:00-04:00",
      "votes": 874
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 729403,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 600367,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 581347,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 544974,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 485038,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 336902,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 266695,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 237046,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 221090,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 217097,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169732,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124099,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 91991,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 60526,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49131,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35103,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20387,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14308,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6446,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 876,
      "timestamp": "2023-03-24T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 732329,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 603696,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 583231,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 546487,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 486730,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 337773,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 267169,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 237667,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 221913,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 218218,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169775,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124148,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 92229,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 60956,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49151,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35155,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20394,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14314,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T21:00:00-04:00",
      "votes": 6446
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 879,
      "timestamp": "2023-03-24T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 733602,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 605901,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 585390,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 546659,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 488169,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 339253,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 267477,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 238196,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 222671,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 218583,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 169904,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124196,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 92445,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 61146,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49163,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35158,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20396,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14333,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6453,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 880,
      "timestamp": "2023-03-24T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 734767,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 606946,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 586362,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 546822,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 490108,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 340406,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 267973,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 238529,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 223341,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 219120,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 170028,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124200,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 92616,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 61287,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49173,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35189,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20402,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14340,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6454,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 881,
      "timestamp": "2023-03-24T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 736665,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 609267,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 587116,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 547762,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 490946,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 341063,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 268529,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 238889,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 223901,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 219888,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 170484,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124211,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 92742,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 61293,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49181,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35193,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20412,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14359,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6456,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T00:00:00-04:00",
      "votes": 881
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 737381,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 610075,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 587276,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 548255,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 491415,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 341470,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 268985,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 239037,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 224173,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 219908,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 170635,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124212,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 92871,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 61458,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49182,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35195,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20413,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T01:00:00-04:00",
      "votes": 14359
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T01:00:00-04:00",
      "votes": 6456
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T01:00:00-04:00",
      "votes": 881
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 737986,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 610409,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 587298,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 548263,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 491712,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 341527,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 269434,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 239093,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 224232,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 219980,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 170723,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124213,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 92965,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 61598,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49202,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35197,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20417,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 14359
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 6456
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 881
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 738722,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 610659,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 587447,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 548644,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 492068,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 341669,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 269613,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 239129,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 224253,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 220342,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 170733,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124214,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 92976,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 61598
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49210,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 35197
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 20417
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 14359
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6457,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 881
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 739209,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 611203,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 587560,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 548654,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 493417,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 341854,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 269661,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 239200,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 224302,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 220961,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171044,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124216,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 92998,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 61598
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49211,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 35197
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 20417
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 14359
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 6457
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T04:00:00-04:00",
      "votes": 881
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 739908,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 611534,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 587996,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 548976,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 493844,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 341983,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 269727,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 239400,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 224329,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 221259,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171046,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124268,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 93014,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 61599,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49212,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35198,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 20417
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14360,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 6457
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 881
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 740765,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 612324,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 588186,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 549425,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 494350,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 342886,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 269784,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 239510,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 224437,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 221418,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171056,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124272,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 93185,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 61636,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49213,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35199,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-25T06:00:00-04:00",
      "votes": 20417
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T06:00:00-04:00",
      "votes": 14360
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6459,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 882,
      "timestamp": "2023-03-25T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 741512,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 613213,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 588473,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 549608,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 495496,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 343075,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 270495,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 239809,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 224604,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 221823,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171062,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124274,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 93216,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 61691,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49230,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35205,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20438,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14361,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6465,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T07:00:00-04:00",
      "votes": 882
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 742540,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 614429,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 588699,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 550025,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 497011,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 343849,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 271060,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 240262,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 224758,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 222188,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171081,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124324,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 93332,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 61735,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49244,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35213,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20444,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14362,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6467,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T08:00:00-04:00",
      "votes": 882
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 744007,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 616341,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 589227,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 551427,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 498863,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 344219,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 271209,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 240553,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 225496,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 222318,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171096,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124338,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 93380,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 62042,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49251,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35219,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20445,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14363,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6469,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T09:00:00-04:00",
      "votes": 882
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 745318,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 619181,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 589642,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 552001,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 499684,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 344796,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 271831,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 240746,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 226015,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 222731,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171111,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124364,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 93600,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 62117,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49266,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35226,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20453,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14375,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T10:00:00-04:00",
      "votes": 6469
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T10:00:00-04:00",
      "votes": 882
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 747348,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 621212,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 591173,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 552994,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 501346,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 345416,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 272321,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 241024,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 226899,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 223148,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171121,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124399,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 93756,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 62196,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49271,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35230,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20458,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14377,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6470,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T11:00:00-04:00",
      "votes": 882
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 749056,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 623285,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 592961,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 554130,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 502227,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 346003,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 272632,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 241233,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 227301,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 223494,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171156,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124444,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 93897,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 62620,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49302,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35243,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20461,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14378,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6476,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 884,
      "timestamp": "2023-03-25T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 750169,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 626405,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 594092,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 555025,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 503298,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 346282,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 273019,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 241428,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 227728,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 223955,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171174,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124469,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 94231,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 63011,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49337,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35244,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20464,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14380,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T13:00:00-04:00",
      "votes": 6476
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T13:00:00-04:00",
      "votes": 884
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 751421,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 628333,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 595569,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 555707,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 505222,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 346455,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 273294,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 241681,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 228222,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 224522,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171549,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124496,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 94878,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 63582,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49439,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T14:00:00-04:00",
      "votes": 35244
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-25T14:00:00-04:00",
      "votes": 20464
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14388,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6480,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T14:00:00-04:00",
      "votes": 884
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 753016,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 629595,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 596245,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 556752,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 505969,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 346689,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 273862,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 241967,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 228469,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 224786,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171598,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124506,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 95143,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 63845,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49465,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35246,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20480,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14394,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6481,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 885,
      "timestamp": "2023-03-25T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 754491,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 631927,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 598016,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 557351,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 506846,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 347110,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 274100,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 242236,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 229071,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 225188,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171619,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124540,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 95172,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 64182,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49504,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35255,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20485,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14397,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6482,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 890,
      "timestamp": "2023-03-25T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 756258,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 633325,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 599546,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 557544,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 508702,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 347585,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 274685,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 242418,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 229638,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 225384,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171715,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124647,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 95251,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 64493,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49552,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35269,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20492,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14402,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6483,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 892,
      "timestamp": "2023-03-25T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 758495,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 635174,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 600210,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 558574,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 510636,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 348518,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 275031,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 242748,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 230093,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 225590,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171820,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124684,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 96137,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 64590,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49563,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35284,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20502,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T18:00:00-04:00",
      "votes": 14402
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T18:00:00-04:00",
      "votes": 6483
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T18:00:00-04:00",
      "votes": 892
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 759878,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 637338,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 600858,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 559576,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 512477,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 348886,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 275444,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 243270,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 230464,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 225908,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171825,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124755,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 96365,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 64738,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49575,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35287,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20504,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14418,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6491,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 894,
      "timestamp": "2023-03-25T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 761463,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 639821,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 601379,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 560326,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 514834,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 349767,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 275786,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 243787,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 230986,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 227043,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171828,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124845,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 96687,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 65073,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49585,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35307,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20507,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14437,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T20:00:00-04:00",
      "votes": 6491
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 895,
      "timestamp": "2023-03-25T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 763155,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 642484,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 602372,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 560431,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 517689,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 350645,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 276387,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 244270,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 231553,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 227702,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171868,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 124944,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 97658,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 65370,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49589,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35314,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20531,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14441,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6494,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 900,
      "timestamp": "2023-03-25T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 765027,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 644853,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 603121,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 561157,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 519654,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 351209,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 277014,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 244685,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 232442,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 228070,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171873,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125022,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 97759,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 65474,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49701,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35319,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20536,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14442,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6496,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T22:00:00-04:00",
      "votes": 900
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 765895,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 648117,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 605835,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 561293,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 521037,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 352079,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 277416,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 245047,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 233191,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 228226,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171908,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125031,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 97897,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66164,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49709,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35335,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20538,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14445,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T23:00:00-04:00",
      "votes": 6496
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 901,
      "timestamp": "2023-03-25T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 767880,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 650928,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 606365,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 561629,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 522680,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 352554,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 277853,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 245323,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 233644,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 228427,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 171922,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125036,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98045,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66254,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49711,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T00:00:00-04:00",
      "votes": 35335
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T00:00:00-04:00",
      "votes": 20538
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T00:00:00-04:00",
      "votes": 14445
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T00:00:00-04:00",
      "votes": 6496
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T00:00:00-04:00",
      "votes": 901
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 769046,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 652035,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 606541,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 562633,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 524029,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 352840,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 278116,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 245411,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 233820,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 228905,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172145,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125071,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98121,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66285,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49715,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T01:00:00-04:00",
      "votes": 35335
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T01:00:00-04:00",
      "votes": 20538
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14447,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T01:00:00-04:00",
      "votes": 6496
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T01:00:00-04:00",
      "votes": 901
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 769848,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 652870,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 607224,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 563097,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 524673,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 352933,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 278235,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 245502,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 234185,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 229022,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172179,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125078,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98156,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66286,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T02:00:00-04:00",
      "votes": 49715
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T02:00:00-04:00",
      "votes": 35335
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20539,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T02:00:00-04:00",
      "votes": 14447
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T02:00:00-04:00",
      "votes": 6496
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T02:00:00-04:00",
      "votes": 901
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 770206,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 653246,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 607581,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 563162,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 525788,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 352944,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 278275,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 245522,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 234279,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 229094,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T03:00:00-04:00",
      "votes": 172179
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T03:00:00-04:00",
      "votes": 125078
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98173,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66303,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49716,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T03:00:00-04:00",
      "votes": 35335
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T03:00:00-04:00",
      "votes": 20539
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14448,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T03:00:00-04:00",
      "votes": 6496
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 902,
      "timestamp": "2023-03-26T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 770403,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 653320,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 607988,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 563168,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 526136,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 352945,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 278336,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 245646,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 234363,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 229102,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172181,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125084,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98333,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Paine College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 66303
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 49716
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 35335
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 20539
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 14448
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 6496
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 902
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 771061,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 654109,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 608136,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 563171,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 526369,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 353172,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 278387,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 245829,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 234390,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 229131,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 172181
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125128,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98335,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66304,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 49716
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 35335
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 20539
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14449,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 6496
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 902
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 772024,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 654352,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 608244,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 563402,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 526927,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 353470,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 278416,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 246032,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 234423,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 229140,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172182,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T06:00:00-04:00",
      "votes": 125128
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T06:00:00-04:00",
      "votes": 98335
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66337,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49717,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T06:00:00-04:00",
      "votes": 35335
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T06:00:00-04:00",
      "votes": 20539
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14451,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6497,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 903,
      "timestamp": "2023-03-26T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 772857,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 655007,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 608453,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 563527,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 527301,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 353557,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 278560,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 246082,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 234643,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 229188,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T07:00:00-04:00",
      "votes": 172182
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125137,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Allen University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "color": "#f96302",
      "timestamp": "2023-03-26T07:00:00-04:00",
      "votes": 98335
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66345,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49718,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35337,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T07:00:00-04:00",
      "votes": 20539
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14452,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T07:00:00-04:00",
      "votes": 6497
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T07:00:00-04:00",
      "votes": 903
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 774055,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 656613,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 608864,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 563847,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 529203,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 353973,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 278961,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 246421,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 234759,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 229396,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172191,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125194,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98341,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66396,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T08:00:00-04:00",
      "votes": 49718
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35339,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20540,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14455,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T08:00:00-04:00",
      "votes": 6497
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 904,
      "timestamp": "2023-03-26T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 776179,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 657757,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 609235,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 564761,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 530177,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 354439,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 279597,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 246704,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 235176,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 229550,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172196,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125199,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98609,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66443,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49722,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35342,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T09:00:00-04:00",
      "votes": 20540
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14460,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6499,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 907,
      "timestamp": "2023-03-26T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 777435,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 659137,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 609781,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 565327,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 531332,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 354984,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 279889,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 246974,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 235626,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 229704,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172257,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125244,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98812,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66460,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T10:00:00-04:00",
      "votes": 49722
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35345,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20543,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14464,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6500,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 910,
      "timestamp": "2023-03-26T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 778852,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 660425,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 610666,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 565845,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 533029,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 355148,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 280349,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 247265,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 236266,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 230381,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172308,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125287,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 98889,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66465,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49725,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35347,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T11:00:00-04:00",
      "votes": 20543
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14468,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6505,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 911,
      "timestamp": "2023-03-26T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 780518,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 662345,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 611189,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 566734,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 534200,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 355695,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 281049,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 247685,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 236706,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 230603,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172312,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125312,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 99059,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66823,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49726,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35359,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20553,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14470,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6506,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T12:00:00-04:00",
      "votes": 911
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 783320,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 663257,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 612118,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 567129,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 535414,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 356351,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 281756,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 248011,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 237501,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 231033,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172405,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125347,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 99246,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66861,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49868,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35370,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-26T13:00:00-04:00",
      "votes": 20553
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14473,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6507,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 917,
      "timestamp": "2023-03-26T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 785280,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 664404,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 613913,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 567374,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 536981,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 357237,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 282704,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 248187,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 238178,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 231345,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172533,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125354,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 99479,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66896,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 49898,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35377,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20554,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14478,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6508,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T14:00:00-04:00",
      "votes": 917
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 787719,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 666988,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 615143,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 568480,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 539581,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 357689,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 283726,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 248566,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 238833,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 231635,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172602,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125416,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 99522,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 66914,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 50003,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35388,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20558,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14485,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T15:00:00-04:00",
      "votes": 6508
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 918,
      "timestamp": "2023-03-26T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 789332,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 669164,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 615889,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 568982,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 541163,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 358529,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 284392,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 249066,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 239606,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 231979,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172622,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125450,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 99614,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 67240,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T16:00:00-04:00",
      "votes": 50003
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35393,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20563,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14488,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T16:00:00-04:00",
      "votes": 6508
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 928,
      "timestamp": "2023-03-26T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 791204,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 670472,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 616694,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 569081,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 542413,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 359345,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 285738,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 249799,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 240315,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 232636,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172631,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125580,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 99777,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 67302,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 50063,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35396,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20565,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14490,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6510,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 950,
      "timestamp": "2023-03-26T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 792800,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 672442,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 617326,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 569585,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 544167,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 360487,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 286321,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 250790,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 241555,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 233155,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172652,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125609,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 99929,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 67517,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 50134,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35397,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20569,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14493,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T18:00:00-04:00",
      "votes": 6510
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 951,
      "timestamp": "2023-03-26T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 794474,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 675604,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 618892,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 570026,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 545166,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 361080,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 286999,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 251986,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 242482,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 233742,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172700,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125783,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 100067,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 67814,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 50160,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35402,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20571,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14498,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6511,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 952,
      "timestamp": "2023-03-26T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 797939,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 676692,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 621445,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 570827,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 549486,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 362231,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 288032,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 253194,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 243522,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 234723,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172736,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125835,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 100641,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 68162,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 50241,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35404,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20574,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14509,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6516,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 956,
      "timestamp": "2023-03-26T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 802105,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 678128,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 623144,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 571597,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 552101,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 363021,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 288575,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 254231,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 245188,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 235915,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172744,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 125895,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 101106,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 68249,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 50261,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35410,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20586,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14511,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6518,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 959,
      "timestamp": "2023-03-26T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 802697,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 678282,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 623869,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 571625,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 552595,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 363448,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 288773,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 255383,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 245811,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 236200,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172748,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 126002,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 101108,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 68336,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 50273,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35417,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20601,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14518,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T22:00:00-04:00",
      "votes": 6518
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 964,
      "timestamp": "2023-03-26T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 803196,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 678386,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 624521,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 571680,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 553065,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 363988,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 289166,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 256599,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 246378,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 236391,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "votes": 172754,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 126093,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 101109,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 68390,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "votes": 50280,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35422,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "votes": 20602,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Meharry Medical College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "votes": 14520,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6519,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 969,
      "timestamp": "2023-03-26T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Fisk University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d9e5975b-e710-4847-897f-a7eba67d5aaa.png",
      "votes": 803281,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Tougaloo College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fb2df36b-d403-44f8-94c8-a684dfa4438f.png",
      "votes": 678420,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Johnson C. Smith University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e194a3cf-71da-43e3-8782-91719f2701ac.png",
      "votes": 624766,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Lane College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/abca5abc-f241-456c-a7b4-3629233cfeae.png",
      "votes": 571700,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Texas College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/e5a5aba5-e153-47ed-baa7-f2ea544d6efa.png",
      "votes": 553288,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Southwestern Christian College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6f0ae48a-3051-43a2-b666-74c7bd5ab9e9.png",
      "votes": 364219,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Wilberforce University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/2bd8b88f-c2a5-4761-be0d-3030f16c3104.png",
      "votes": 289222,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Morris Brown College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/d6e7635f-4845-4ce6-81dd-5c36d86e8f7d.png",
      "votes": 256727,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Rust College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/1e04aee0-fa57-4522-902d-48bdf211fed4.png",
      "votes": 246626,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Saint Augustine's University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/70ca77df-8c4b-4290-86a2-b5eafd8a3feb.png",
      "votes": 236403,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Philander Smith College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/223d20cb-7b41-47dd-90b5-7ec3f190b70c.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 172754
    },
    {
      "label": "Voorhees University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b5f44515-9bb2-4e4f-9564-4b15604cc4b5.png",
      "votes": 126156,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Allen University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c21345a7-b270-4dc2-b6f5-4786eec16572.jpg",
      "votes": 101111,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Paine College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7d518f7e-7549-41ee-9db4-29a1ab793d52.png",
      "votes": 68392,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Livingstone College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/eabc313d-ac0d-45a5-b0aa-c006967f3677.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 50280
    },
    {
      "label": "Dillard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/414e6243-da62-4fa4-b470-8a733fc650b1.png",
      "votes": 35423,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Stillman College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/67939b4a-e72c-4282-bd50-be392aabb4fd.jpeg",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 20602
    },
    {
      "label": "Meharry Medical College",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/76841463-5b37-459a-8009-d15a89ba66bf.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 14520
    },
    {
      "label": "Edward Waters University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fca7c39-2395-416c-8bc2-78e0a31eb47a.png",
      "votes": 6520,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Interdenominational Theological Center",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/4a5ee95f-6bd6-45e5-aef9-36907b5d8262.png",
      "votes": 970,
      "timestamp": "2023-03-27T00:00:00-04:00"
    }
  ]
]
